export const stores = [
  {
    "identifier": "21959",
    "id": 3132672,
    "dateCreated": "2021-12-22T00:20:54.000+01:00",
    "lastUpdated": "2025-06-04T20:31:23.000+02:00",
    "name": "CheckSmart",
    "street": "Sam Walton Drive",
    "streetNo": "300",
    "streetAndNumber": "300 Sam Walton Drive",
    "addressExtra": "Suite 1300",
    "zip": "42503",
    "city": "Somerset",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/somerset/300-sam-walton-drive/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "Need money now? Avoid a money mayday®, whether you need a Somerset, Kentucky Payday Loan, or other financial services, CheckSmart is here.",
    "descriptionLong": "Need money now? Stress less and avoid a money mayday®by stopping by your local CheckSmart here in the Somerset, Kentucky store. From SomerSplash Waterpark to the International Paranormal Museum and Research Center and beyond we've helped our local customers and communities with short-term financial solutions for 30 years. Whether you need a Somerset, Kentucky Payday Loan, or other financial services, CheckSmart is here. Check in with us at 300 Sam Walton Drive, Somerset, KY, 42503, we're next to GameStop.\n\nYou'll find working with our team to be quick, easy and confidential. To apply for the quick loan you need, you'll need proof of your open and active checking account, your government-issued photo ID, and proof of income. Stop by our Kentucky CheckSmart today or call for more information. If approved, you can walk out with cash in your hand!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:56:15.000+02:00",
    "country": "US",
    "lat": 37.07014,
    "lng": -84.62279,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 606-451-3136",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 112044650,
        "dateCreated": "2023-03-22T15:55:56.000+01:00",
        "repoKey": "HpjlbOWoRN.png",
        "locationId": 3132672,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": false,
        "type": "LANDSCAPE",
        "url": "/uploads/userpics/3132672/HpjlbOWoRN.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3132672/HpjlbOWoRN.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3132672/thumb_HpjlbOWoRN.png",
        "cropHeight": 720,
        "cropWidth": 1280,
        "cropOffsetX": 0,
        "cropOffsetY": 0,
        "sourceUrl": null
      }
    ],
    "keywords": [
      "cash advance",
      "cash advance near me",
      "cashing near me",
      "Check into cash near me",
      "Flex loans near me",
      "Installment loan near me",
      "line of credit near me",
      "Money order near me",
      "money transfer near me",
      "payday loans",
      "payday loans near me",
      "same day loans",
      "Sell gift cards",
      "title loan near me"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465
    ],
    "locationSyncable": false,
    "businessId": 1298283,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2024-01-01T00:00:00.000+01:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 906,
    "dataPoints": 13,
    "linkedToLocationGroups": [
      {
        "name": "KY",
        "id": 1344
      },
      {
        "name": "A Stores",
        "id": 1361
      },
      {
        "name": "'z - fb lat-long discrepancies",
        "id": 1363
      },
      {
        "name": "Services - Check Cashing",
        "id": 1364
      },
      {
        "name": "Services - Payday Advances",
        "id": 1367
      },
      {
        "name": "Services - Western Union",
        "id": 1373
      },
      {
        "name": "Services - Bill Pay",
        "id": 1374
      },
      {
        "name": "Services - U.S. Money Prepaid Card",
        "id": 1375
      },
      {
        "name": "Services - Gift Card Buying",
        "id": 1376
      },
      {
        "name": "Services - Cell Phone Top Offs",
        "id": 1377
      },
      {
        "name": "NewLocation0517",
        "id": 1379
      },
      {
        "name": "Check Into Cash",
        "id": 1395
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20330",
    "id": 3354803,
    "dateCreated": "2022-05-17T15:49:36.000+02:00",
    "lastUpdated": "2025-06-04T03:59:18.000+02:00",
    "name": "CheckSmart",
    "street": "South Nappanee Street",
    "streetNo": "1528",
    "streetAndNumber": "1528 South Nappanee Street",
    "addressExtra": null,
    "zip": "46516",
    "city": "Elkhart",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/elkhart/1528-south-nappanee-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it doesn't have to be a long drawn-out process. CheckSmart, conveniently located on S. Nappanee St. in Elkhart, IN, can help walk you through our simple application process and have you out the door with cash in hand in no time at all once you're approved. We offer Payroll Advance Loans up to $660 to our qualified customers. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. When you need cash, the team at CheckSmart will work with you to find the solution that best fits your situation.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 41.67341,
    "lng": -86.00256,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 574-294-5906",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742620,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "3Ll3ZN1Qaw.jpeg",
        "locationId": 3354803,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3354803/3Ll3ZN1Qaw.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354803/medium_3Ll3ZN1Qaw.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354803/thumb_3Ll3ZN1Qaw.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354803/Dk6OUbikcP.jpeg"
      }
    ],
    "keywords": [
      "check cashing elkhart",
      "checksmart elkhart",
      "payday loans elkhart"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-17T15:49:36.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 854,
    "dataPoints": 133,
    "linkedToLocationGroups": [
      {
        "name": "NewLocationMay17",
        "id": 1380
      },
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "22129",
    "id": 3354806,
    "dateCreated": "2022-05-17T15:49:38.000+02:00",
    "lastUpdated": "2025-06-03T23:28:46.000+02:00",
    "name": "CheckSmart",
    "street": "West Valencia Road",
    "streetNo": "1655",
    "streetAndNumber": "1655 West Valencia Road",
    "addressExtra": "Suite 121",
    "zip": "85746",
    "city": "Tucson",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/tucson/1655-west-valencia-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "We look forward to helping every customer who walks through our doors here at CheckSmart. Stop by the Valencia Rd. location in Tucson, AZ to learn more about the loans we have available and speak to a team member about the application process. We're here to help, and if you're approved you could access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. We're here for you when you need us, so give us a call or stop by the store today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:05.000+02:00",
    "country": "US",
    "lat": 32.1333668,
    "lng": -111.00004587,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 520-434-2700",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742626,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "JGKlqbUwjg.jpeg",
        "locationId": 3354806,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3354806/JGKlqbUwjg.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354806/medium_JGKlqbUwjg.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354806/thumb_JGKlqbUwjg.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354806/NGU5qKNXdr.jpeg"
      }
    ],
    "keywords": [
      "check cashing tucson",
      "checksmart tucson",
      "installment loans tucson",
      "payday loans tucson",
      "title loans tucson"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-17T15:49:38.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 861,
    "dataPoints": 73,
    "linkedToLocationGroups": [
      {
        "name": "NewLocationMay17",
        "id": 1380
      },
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "22929",
    "id": 3354805,
    "dateCreated": "2022-05-17T15:49:38.000+02:00",
    "lastUpdated": "2025-06-03T23:28:46.000+02:00",
    "name": "CheckSmart",
    "street": "West Northern Avenue",
    "streetNo": "3449",
    "streetAndNumber": "3449 West Northern Avenue",
    "addressExtra": null,
    "zip": "85051",
    "city": "Phoenix",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/phoenix/3449-west-northern-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need quick access to cash, CheckSmart is here to help. Visit our Phoenix, AZ store on W. Northern Ave to connect with one of our team members and learn more about all Check Smart has to offer. If you qualify for one of our loans, you could receive up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here to make things easier for you when life throws a curveball your way, so stop by today to get the process started.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:05.000+02:00",
    "country": "US",
    "lat": 33.55259,
    "lng": -112.13392,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 602-841-3393",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742648,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "ELvsXNKAgr.jpeg",
        "locationId": 3354805,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3354805/ELvsXNKAgr.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354805/medium_ELvsXNKAgr.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354805/thumb_ELvsXNKAgr.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354805/AhDLYsZsd7.jpeg"
      }
    ],
    "keywords": [
      "check cashing phoenix",
      "checksmart phoenix",
      "installment loans phoenix",
      "payday loans phoenix",
      "title loans phoenix"
    ],
    "labels": [
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-17T15:49:37.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 854,
    "dataPoints": 112,
    "linkedToLocationGroups": [
      {
        "name": "NewLocationMay17",
        "id": 1380
      },
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "20230",
    "id": 3354808,
    "dateCreated": "2022-05-17T15:49:39.000+02:00",
    "lastUpdated": "2025-06-03T23:28:51.000+02:00",
    "name": "CheckSmart",
    "street": "West McKinley Avenue",
    "streetNo": "813",
    "streetAndNumber": "813 West McKinley Avenue",
    "addressExtra": null,
    "zip": "46545",
    "city": "Mishawaka",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/mishawaka/813-west-mckinley-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart and the team of Loan Experts on staff at our W. McKinley Ave. store in Mishawaka, IN can help when life presents challenges that require cash solutions. Stop by the store today to apply and if approved you'll be on your way, cash in hand, in no time at all. To qualified applicants, we offer Payroll Advance Loans up to $660. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We look forward to helping you, so if you have questions don't hesitate to reach out today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 41.67978,
    "lng": -86.1927,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 574-259-5888",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742618,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "1trOXnmRCu.jpeg",
        "locationId": 3354808,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3354808/1trOXnmRCu.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354808/medium_1trOXnmRCu.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354808/thumb_1trOXnmRCu.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354808/uwswHJnHEn.jpeg"
      }
    ],
    "keywords": [
      "check cashing mishawaka",
      "checksmart mishawaka",
      "installment loans mishawaka",
      "payday loans mishawaka",
      "title loans mishawaka"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-17T15:49:39.000+02:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 861,
    "dataPoints": 209,
    "linkedToLocationGroups": [
      {
        "name": "NewLocationMay17",
        "id": 1380
      },
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21429",
    "id": 3354807,
    "dateCreated": "2022-05-17T15:49:39.000+02:00",
    "lastUpdated": "2025-06-03T23:28:46.000+02:00",
    "name": "CheckSmart",
    "street": "West Lower Buckeye Road",
    "streetNo": "7710",
    "streetAndNumber": "7710 West Lower Buckeye Road",
    "addressExtra": "#100",
    "zip": "85043",
    "city": "Phoenix",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/phoenix/7710-west-lower-buckeye-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When life throws a wrench in your plans and you need cash quickly, CheckSmart is here to help. Our team members at the Lower Buckeye Rd. location in Phoenix, AZ can answer all of your questions and help you apply for the loan that will best fit your unique situation. If approved, you could access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers an array financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. We look forward to working with you, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:04.000+02:00",
    "country": "US",
    "lat": 33.42362018,
    "lng": -112.22566563,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 623-936-9400",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742615,
        "dateCreated": "2025-04-17T16:23:22.000+02:00",
        "repoKey": "Tk6Dyyk4F3.jpeg",
        "locationId": 3354807,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3354807/Tk6Dyyk4F3.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354807/medium_Tk6Dyyk4F3.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354807/thumb_Tk6Dyyk4F3.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3354807/lCWv0ENjkl.jpeg"
      }
    ],
    "keywords": [
      "check cashing phoenix",
      "checksmart phoenix",
      "installment loans phoenix",
      "payday loans phoenix",
      "title loans phoenix"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-17T15:49:39.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 858,
    "dataPoints": 78,
    "linkedToLocationGroups": [
      {
        "name": "NewLocationMay17",
        "id": 1380
      },
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "20130",
    "id": 3363526,
    "dateCreated": "2022-05-27T06:33:12.000+02:00",
    "lastUpdated": "2025-06-01T16:31:25.000+02:00",
    "name": "CheckSmart",
    "street": "South Michigan Street",
    "streetNo": "1711",
    "streetAndNumber": "1711 South Michigan Street",
    "addressExtra": null,
    "zip": "46613",
    "city": "South Bend",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/south-bend/1711-south-michigan-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When life presents a problem that can only be solved through a cash solution, choose CheckSmart to assist you. Our team at the conveniently located store on Michigan St. in South Bend, IN will walk you through the application process step-by-step, so stop by today! We offer Payroll Advance Loans up to $660 to our qualified customers. We're more than your go-to loan company! Our store offers an array financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. When you need a team you can count on, choose CheckSmart.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 41.65642,
    "lng": -86.2503,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 574-287-8745",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742606,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "ypGurgHEJP.jpeg",
        "locationId": 3363526,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363526/ypGurgHEJP.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363526/medium_ypGurgHEJP.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363526/thumb_ypGurgHEJP.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363526/gDOriBrlgN.jpeg"
      }
    ],
    "keywords": [
      "check cashing south bend",
      "checksmart south bend",
      "payday loans south bend"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:12.000+02:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 97,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21630",
    "id": 3363527,
    "dateCreated": "2022-05-27T06:33:13.000+02:00",
    "lastUpdated": "2025-06-04T18:03:44.000+02:00",
    "name": "CheckSmart",
    "street": "East 82nd Street",
    "streetNo": "6621",
    "streetAndNumber": "6621 East 82nd Street",
    "addressExtra": null,
    "zip": "46250",
    "city": "Indianapolis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/indianapolis/6621-east-82nd-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Need access to cash and not sure where to turn? CheckSmart on E. 82nd St. in Indianapolis, IN is here to help, so stop by to apply today. If approved, you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here to help you get things on track when you need us, so stop by today and get the ball rolling with an application in store. Our team is ready to help!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 39.9043,
    "lng": -86.05315,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-576-8004",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742608,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "v5ypJgng9m.jpeg",
        "locationId": 3363527,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363527/v5ypJgng9m.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363527/medium_v5ypJgng9m.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363527/thumb_v5ypJgng9m.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363527/0EsOaxGS2V.jpeg"
      }
    ],
    "keywords": [
      "check cashing indianapolis",
      "checksmart indianapolis",
      "payday loans indianapolis"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:13.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 97,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "20430",
    "id": 3363529,
    "dateCreated": "2022-05-27T06:33:14.000+02:00",
    "lastUpdated": "2025-06-04T18:02:51.000+02:00",
    "name": "CheckSmart",
    "street": "Elkhart Road",
    "streetNo": "1607",
    "streetAndNumber": "1607 Elkhart Road",
    "addressExtra": null,
    "zip": "46526",
    "city": "Goshen",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/goshen/1607-elkhart-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "If you're looking for access to cash and a team focused on customer service, look no further than the Loan Experts at CheckSmart! Our team at the Elkhart Rd. location in Goshen, IN will walk you through the application process, so stop by today! To qualified applicants, we offer Payroll Advance Loans up to $660. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here for you when you need us, and we can help you find the loan solution that is right for your situation.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 41.59272,
    "lng": -85.85571,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 574-533-9952",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742614,
        "dateCreated": "2025-04-17T16:23:22.000+02:00",
        "repoKey": "5lBtC8O0yl.jpeg",
        "locationId": 3363529,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363529/5lBtC8O0yl.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363529/medium_5lBtC8O0yl.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363529/thumb_5lBtC8O0yl.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363529/mpG65ihn6B.jpeg"
      }
    ],
    "keywords": [
      "check cashing goshen",
      "checksmart goshen",
      "payday loans goshen"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:14.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 861,
    "dataPoints": 56,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21430",
    "id": 3363528,
    "dateCreated": "2022-05-27T06:33:14.000+02:00",
    "lastUpdated": "2025-06-03T23:31:16.000+02:00",
    "name": "CheckSmart",
    "street": "South East Street",
    "streetNo": "3429",
    "streetAndNumber": "3429 South East Street",
    "addressExtra": null,
    "zip": "46227",
    "city": "Indianapolis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/indianapolis/3429-south-east-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Accessing cash when you need it starts with a trip to CheckSmart. Stop by the store on S. East Street in Indianapolis, IN today to learn more about our in-store services and options and to complete the application process with one of our team members when applying for a loan! To our qualified customers, we can offer up $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Connect with our team, in store, today to learn more and to get the process started!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:53.000+02:00",
    "country": "US",
    "lat": 39.71598,
    "lng": -86.14837,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-782-4400",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742607,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "uItvUoeXbs.jpeg",
        "locationId": 3363528,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363528/uItvUoeXbs.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363528/medium_uItvUoeXbs.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363528/thumb_uItvUoeXbs.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363528/NzcDtYXe62.jpeg"
      }
    ],
    "keywords": [
      "check cashing indianapolis",
      "checksmart indianapolis",
      "payday loans indianapolis"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:13.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 864,
    "dataPoints": 94,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "20730",
    "id": 3363530,
    "dateCreated": "2022-05-27T06:33:15.000+02:00",
    "lastUpdated": "2025-06-02T20:31:30.000+02:00",
    "name": "CheckSmart",
    "street": "East State Boulevard",
    "streetNo": "2839",
    "streetAndNumber": "2839 East State Boulevard",
    "addressExtra": null,
    "zip": "46805",
    "city": "Fort Wayne",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/fort-wayne/2839-east-state-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Accessing cash when you need it does not have to be a complicated process, and the first step is a convenient trip to CheckSmart. Our team at the E. State Blvd. location in Fort Wayne, IN will walk you through the application process and make things simple, so stop by to discuss your loan options today! If approved, you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Stop by today to learn more about the options at CheckSmart; we're here for you when you need us!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 41.09758511,
    "lng": -85.10227195,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 260-496-8885",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742613,
        "dateCreated": "2025-04-17T16:23:22.000+02:00",
        "repoKey": "HmDXsIyRe9.jpeg",
        "locationId": 3363530,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363530/HmDXsIyRe9.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363530/medium_HmDXsIyRe9.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363530/thumb_HmDXsIyRe9.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363530/6zeBylQG3W.jpeg"
      }
    ],
    "keywords": [
      "check cashing fort wayne",
      "checksmart fort wayne",
      "payday loans fort wayne"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:15.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 48,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21830",
    "id": 3363532,
    "dateCreated": "2022-05-27T06:33:16.000+02:00",
    "lastUpdated": "2025-06-03T23:31:16.000+02:00",
    "name": "CheckSmart",
    "street": "West County Line Road",
    "streetNo": "905",
    "streetAndNumber": "905 West County Line Road",
    "addressExtra": null,
    "zip": "46142",
    "city": "Greenwood",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/greenwood/905-west-county-line-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Providing access to cash when you need it is our specialty here at CheckSmart. Our team at the W. County Line Rd. location in Greenwood, IN will walk you through the application process step-by-step, so stop by the store today to get started. If approved, you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. The CheckSmart team of Loan Experts is standing by and ready to help you find the loan and cash solution that will help with your unique situation, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 39.63514,
    "lng": -86.1276,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-888-0011",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742673,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "jydHJzv2D0.jpeg",
        "locationId": 3363532,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363532/jydHJzv2D0.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363532/medium_jydHJzv2D0.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363532/thumb_jydHJzv2D0.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363532/pkdmMfVKbo.jpeg"
      }
    ],
    "keywords": [
      "check cashing greenwood",
      "checksmart greenwood",
      "payday loans greenwood"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:16.000+02:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 843,
    "dataPoints": 73,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "22630",
    "id": 3363533,
    "dateCreated": "2022-05-27T06:33:17.000+02:00",
    "lastUpdated": "2025-06-03T23:31:17.000+02:00",
    "name": "CheckSmart",
    "street": "Eastern Boulevard",
    "streetNo": "907",
    "streetAndNumber": "907 Eastern Boulevard",
    "addressExtra": null,
    "zip": "47129",
    "city": "Clarksville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/clarksville/907-eastern-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, CheckSmart has you covered. Cash solutions are just around the corner at the Eastern Blvd. location of Check Smart in Clarksville, IN. After you've completed the loan process and received the green light of approval, you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Our team is always ready to help and answer your questions, so pop by the store today.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 38.30315,
    "lng": -85.7654,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 812-288-4209",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742612,
        "dateCreated": "2025-04-17T16:23:22.000+02:00",
        "repoKey": "Vj8ooSLZ3r.jpeg",
        "locationId": 3363533,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363533/Vj8ooSLZ3r.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363533/medium_Vj8ooSLZ3r.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363533/thumb_Vj8ooSLZ3r.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363533/9FDQok4mIo.jpeg"
      }
    ],
    "keywords": [
      "check cashing clarksville",
      "checksmart clarksville",
      "payday loans clarksville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:17.000+02:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 82,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "21530",
    "id": 3363535,
    "dateCreated": "2022-05-27T06:33:18.000+02:00",
    "lastUpdated": "2025-06-04T16:08:33.000+02:00",
    "name": "CheckSmart",
    "street": "Shadeland Avenue",
    "streetNo": "1058",
    "streetAndNumber": "1058 Shadeland Avenue",
    "addressExtra": null,
    "zip": "46219",
    "city": "Indianapolis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/indianapolis/1058-shadeland-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need cash in hand in a quick time frame, the team at CheckSmart is here to help. Our team at the N. Shadeland Ave. location in Indianapolis, IN can walk you through the application process step-by-step, so pop by the store today to get started! Once approved you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We make helping our customers the top focus of our day, so stop by and experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 39.78278,
    "lng": -86.04601,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-353-0700",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742624,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "OZwszAfdIt.jpeg",
        "locationId": 3363535,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363535/OZwszAfdIt.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363535/medium_OZwszAfdIt.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363535/thumb_OZwszAfdIt.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363535/qBsYeN4KlP.jpeg"
      }
    ],
    "keywords": [
      "check cashing indianapolis",
      "checksmart indianapolis",
      "payday loans indianapolis"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:18.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 854,
    "dataPoints": 182,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "22230",
    "id": 3363534,
    "dateCreated": "2022-05-27T06:33:18.000+02:00",
    "lastUpdated": "2025-06-03T23:31:17.000+02:00",
    "name": "CheckSmart",
    "street": "East Main Street",
    "streetNo": "2235",
    "streetAndNumber": "2235 East Main Street",
    "addressExtra": null,
    "zip": "46168",
    "city": "Plainfield",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/plainfield/2235-east-main-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash isn't complicated when you work with the fantastic team at CheckSmart. Our East Main St. location in Plainfield, IN is conveniently located, so stop by today to apply for the loan that best fits your needs. Once approved you could access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. We're here to help when life throws an unexpected wrench in your plans or if you just need a little extra helping hand, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 39.7115839,
    "lng": -86.37175865,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-837-1185",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742625,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "SZLTqPtb2S.jpeg",
        "locationId": 3363534,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363534/SZLTqPtb2S.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363534/medium_SZLTqPtb2S.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363534/thumb_SZLTqPtb2S.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363534/3uBFMw1njS.jpeg"
      }
    ],
    "keywords": [
      "check cashing plainfield",
      "checksmart plainfield",
      "payday loans plainfield"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:17.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 91,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "20930",
    "id": 3363536,
    "dateCreated": "2022-05-27T06:33:19.000+02:00",
    "lastUpdated": "2025-06-03T23:31:17.000+02:00",
    "name": "CheckSmart",
    "street": "East Rudisill Boulevard",
    "streetNo": "212",
    "streetAndNumber": "212 East Rudisill Boulevard",
    "addressExtra": null,
    "zip": "46806",
    "city": "Fort Wayne",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/fort-wayne/212-east-rudisill-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it needs to be convenient and CheckSmart works hard to make the process simple. Stop by the E. Rudisill Blvd. location in Fort Wayne, IN to apply, and you'll be on your way with cash in hand in no time at all if approved. We offer up to $660 through a Payroll Advance Loan to our qualified customers. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Pop by and discuss your options with a team member, today, and you'll be on your way and back to business in no time at all.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 41.0497706,
    "lng": -85.13417087,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 260-456-3338",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742622,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "LtbdF8LOBN.jpeg",
        "locationId": 3363536,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363536/LtbdF8LOBN.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363536/medium_LtbdF8LOBN.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363536/thumb_LtbdF8LOBN.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363536/yd53512smJ.jpeg"
      }
    ],
    "keywords": [
      "check cashing fort wayne",
      "checksmart fort wayne",
      "payday loans fort wayne"
    ],
    "labels": [
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:19.000+02:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 857,
    "dataPoints": 53,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21730",
    "id": 3363538,
    "dateCreated": "2022-05-27T06:33:20.000+02:00",
    "lastUpdated": "2025-06-04T16:09:39.000+02:00",
    "name": "CheckSmart",
    "street": "Pendleton Pike",
    "streetNo": "8601",
    "streetAndNumber": "8601 Pendleton Pike",
    "addressExtra": null,
    "zip": "46235",
    "city": "Indianapolis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/indianapolis/8601-pendleton-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need cash to handle the curveballs life loves to throw at us, CheckSmart is here to help you get back in the game. Stop by the Pendleton Pike location in Indianapolis, IN and connect with a team member to learn about the loan options we have available. Once qualified, you can access up to $660 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Once approved, you'll be on your way with cash in hand in no time.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 39.84105923,
    "lng": -86.0166924,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-890-1990",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742657,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "LclKwFYFNl.jpeg",
        "locationId": 3363538,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363538/LclKwFYFNl.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363538/medium_LclKwFYFNl.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363538/thumb_LclKwFYFNl.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363538/k96wsByHbM.jpeg"
      }
    ],
    "keywords": [
      "check cashing indianapolis",
      "checksmart indianapolis",
      "payday loans indianapolis"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Indiana",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:20.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 880,
    "dataPoints": 99,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "22130",
    "id": 3363537,
    "dateCreated": "2022-05-27T06:33:20.000+02:00",
    "lastUpdated": "2025-06-04T16:10:36.000+02:00",
    "name": "CheckSmart",
    "street": "Crawfordsville Road",
    "streetNo": "5960",
    "streetAndNumber": "5960 Crawfordsville Road",
    "addressExtra": null,
    "zip": "46224",
    "city": "Indianapolis",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/in/indianapolis/5960-crawfordsville-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Short on cash and need a helping hand from a team you can trust? Look no further than CheckSmart on Crawfordsville Rd. in Indianapolis, IN and stop by today to walk through the application process with our team. We can offer up to $660 through a Payroll Advance Loan to qualified applicants. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Our team is dedicated to exceptional customer service, and we're here to help when you need us so stop by!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:52.000+02:00",
    "country": "US",
    "lat": 39.7993,
    "lng": -86.26527,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 317-270-9332",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742659,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "8q8Elv9F7p.jpeg",
        "locationId": 3363537,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3363537/8q8Elv9F7p.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363537/medium_8q8Elv9F7p.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363537/thumb_8q8Elv9F7p.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3363537/xqXUSkq7bo.jpeg"
      }
    ],
    "keywords": [
      "check cashing indianapolis",
      "checksmart indianapolis",
      "payday loans indianapolis"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Indiana",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-27T06:33:20.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 874,
    "dataPoints": 134,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Indiana",
        "id": 1382
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "20338",
    "id": 3365609,
    "dateCreated": "2022-05-31T13:24:23.000+02:00",
    "lastUpdated": "2025-06-02T20:32:08.000+02:00",
    "name": "CheckSmart",
    "street": "Montgomery Road",
    "streetNo": "3834",
    "streetAndNumber": "3834 Montgomery Road",
    "addressExtra": null,
    "zip": "45212",
    "city": "Norwood",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/norwood/3834-montgomery-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to a wide range of financial services in one convenient location shouldn't be complicated, and CheckSmart works hard to make your transactions as quick and as convenient as possible. Stop by the Montgomery Rd. location of CheckSmart in Norwood, OH to experience the difference our dedicated team makes each day for our customers. We work hard to make sure our customers are in and out quickly and without hassle. Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Pop by our store! We're here to help.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:04.000+02:00",
    "country": "US",
    "lat": 39.1493437,
    "lng": -84.4647347,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-731-8200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742672,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "doJy1Z6ZD9.jpeg",
        "locationId": 3365609,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365609/doJy1Z6ZD9.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365609/medium_doJy1Z6ZD9.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365609/thumb_doJy1Z6ZD9.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365609/v8ZlObGoLc.jpeg"
      }
    ],
    "keywords": [
      "check cashing norwood",
      "checksmart norwood",
      "line of credit norwood"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:23.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 858,
    "dataPoints": 296,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26238",
    "id": 3365611,
    "dateCreated": "2022-05-31T13:24:24.000+02:00",
    "lastUpdated": "2025-06-04T12:07:10.000+02:00",
    "name": "CheckSmart",
    "street": "Northfield Road",
    "streetNo": "4626",
    "streetAndNumber": "4626 Northfield Road",
    "addressExtra": null,
    "zip": "44128",
    "city": "North Randall",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/north-randall/4626-northfield-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Looking for a great team to work with and a convenient location to complete all of your financial services transactions? CheckSmart on Northfield Rd. in North Randall, OH can help. Our store offers a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team looks forward to answering any questions you may have and helping you complete your transactions and get back to your busy day quickly and without a hassle. Stop by today to experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:04.000+02:00",
    "country": "US",
    "lat": 41.4314523,
    "lng": -81.52638409,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 216-714-4324",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742647,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "e4A4QyH07H.jpeg",
        "locationId": 3365611,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365611/e4A4QyH07H.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365611/medium_e4A4QyH07H.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365611/thumb_e4A4QyH07H.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365611/k6PlMw8na7.jpeg"
      }
    ],
    "keywords": [
      "check cashing north randall",
      "checksmart north randall",
      "line of credit north randall"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:24.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 870,
    "dataPoints": 226,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26638",
    "id": 3365612,
    "dateCreated": "2022-05-31T13:24:25.000+02:00",
    "lastUpdated": "2025-06-04T12:05:36.000+02:00",
    "name": "CheckSmart",
    "street": "Mentor Avenue",
    "streetNo": "1219",
    "streetAndNumber": "1219 Mentor Avenue",
    "addressExtra": null,
    "zip": "44077",
    "city": "Painesville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/painesville/1219-mentor-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need to complete the financial services items on your to-do list and want to work with a team you can count on for answers to all of your questions, look no further than CheckSmart. Our dedicated team at the Mentor Avenue location in Painesville, OH can help quickly and efficiently with all of your needs in one convenient location! We offer a wide variety of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team looks forward to serving you, so stop by today.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:04.000+02:00",
    "country": "US",
    "lat": 41.70511129,
    "lng": -81.26787139,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 440-392-2274",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742639,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "CY8iN5exaY.jpeg",
        "locationId": 3365612,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365612/CY8iN5exaY.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365612/medium_CY8iN5exaY.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365612/thumb_CY8iN5exaY.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365612/3OMYGlHBQc.jpeg"
      }
    ],
    "keywords": [
      "check cashing painesville",
      "checksmart painesville",
      "line of credit painesville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:25.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 189,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20438",
    "id": 3365613,
    "dateCreated": "2022-05-31T13:24:26.000+02:00",
    "lastUpdated": "2025-06-04T12:01:03.000+02:00",
    "name": "CheckSmart",
    "street": "East Kemper Road",
    "streetNo": "129",
    "streetAndNumber": "129 East Kemper Road",
    "addressExtra": null,
    "zip": "45246",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/129-east-kemper-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "If you need convenient, quick access to financial services, look no further than CheckSmart in Cincinnati, OH. Our store on Kemper Rd. is conveniently located and our team will walk you through your transaction plus answer any questions you may have! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to creating exceptional customer experiences for everyone who walks through our doors. Experience the CheckSmart difference for yourself the next time you need help completing a financial services transaction!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 39.2872504,
    "lng": -84.4651407,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-772-4520",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742663,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "0gCs8Pzyyi.jpeg",
        "locationId": 3365613,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365613/0gCs8Pzyyi.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365613/medium_0gCs8Pzyyi.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365613/thumb_0gCs8Pzyyi.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365613/N6YTvDi0Yl.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:25.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 115,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26838",
    "id": 3365615,
    "dateCreated": "2022-05-31T13:24:27.000+02:00",
    "lastUpdated": "2025-06-01T16:32:04.000+02:00",
    "name": "CheckSmart",
    "street": "Mayfield Road",
    "streetNo": "5885",
    "streetAndNumber": "5885 Mayfield Road",
    "addressExtra": null,
    "zip": "44124",
    "city": "Mayfield Heights",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/mayfield-heights/5885-mayfield-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to a wide range of financial services in one convenient location, CheckSmart can offer you solutions! Our store on Mayfield Rd. in Mayfield Heights, OH has a team of experts standing by ready to help. Our in-store financial services include Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to creating amazing customer experiences to everyone who walks through our door, so stop by today to see the CheckSmart difference for yourself!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 41.52047662,
    "lng": -81.46734315,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 440-442-7345",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742641,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "RSjGS1aKxB.jpeg",
        "locationId": 3365615,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365615/RSjGS1aKxB.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365615/medium_RSjGS1aKxB.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365615/thumb_RSjGS1aKxB.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365615/S7moDY7nWn.jpeg"
      }
    ],
    "keywords": [
      "check cashing mayfield heights",
      "checksmart mayfield heights",
      "line of credit mayfield heights"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:27.000+02:00",
    "averageRating": 5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 44,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22338",
    "id": 3365616,
    "dateCreated": "2022-05-31T13:24:28.000+02:00",
    "lastUpdated": "2025-06-04T12:02:27.000+02:00",
    "name": "CheckSmart",
    "street": "Telegraph Road",
    "streetNo": "5801",
    "streetAndNumber": "5801 Telegraph Road",
    "addressExtra": null,
    "zip": "43612",
    "city": "Toledo",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/toledo/5801-telegraph-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Stop by your neighborhood CheckSmart store today to learn more about our financial services options and our dedication to customer service. Our team at the Toledo, OH store on Telegraph Rd. can answer all of your questions and will have you on your way, back to your busy day, in no time at all. We offer a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to creating excellent customer experiences, so stop by today to find out why CheckSmart is the best!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 41.7225915,
    "lng": -83.54819,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 419-476-8785",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742680,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "u3LhXo7fBG.jpeg",
        "locationId": 3365616,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365616/u3LhXo7fBG.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365616/medium_u3LhXo7fBG.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365616/thumb_u3LhXo7fBG.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365616/fzMZBDGlJo.jpeg"
      }
    ],
    "keywords": [
      "check cashing toledo",
      "checksmart toledo",
      "line of credit toledo"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:27.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 156,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22438",
    "id": 3365617,
    "dateCreated": "2022-05-31T13:24:28.000+02:00",
    "lastUpdated": "2025-06-04T11:56:44.000+02:00",
    "name": "CheckSmart",
    "street": "South Reynolds Road",
    "streetNo": "1221",
    "streetAndNumber": "1221 South Reynolds Road",
    "addressExtra": null,
    "zip": "43615",
    "city": "Toledo",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/toledo/1221-south-reynolds-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you have a long to-do list that includes financial services related tasks, CheckSmart is here to help. Our team at the Toledo, OH store on Reynolds Rd. will help you complete your transactions quickly and without hassle. Our store offers a range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Excellent customer service and providing service solutions for our customers are the goals of everyone at CheckSmart, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 41.61818,
    "lng": -83.66415,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 419-382-5385",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742642,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "YedRuQkSDW.jpeg",
        "locationId": 3365617,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365617/YedRuQkSDW.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365617/medium_YedRuQkSDW.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365617/thumb_YedRuQkSDW.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365617/WYoibWJJ1c.jpeg"
      }
    ],
    "keywords": [
      "check cashing toledo",
      "checksmart toledo",
      "line of credit toledo"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:28.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 201,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21738",
    "id": 3365619,
    "dateCreated": "2022-05-31T13:24:30.000+02:00",
    "lastUpdated": "2025-06-03T23:31:55.000+02:00",
    "name": "CheckSmart",
    "street": "Stahlheber Road",
    "streetNo": "800",
    "streetAndNumber": "800 Stahlheber Road",
    "addressExtra": null,
    "zip": "45013",
    "city": "Hamilton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/hamilton/800-stahlheber-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "At CheckSmart, we believe that completing all of your financial services transactions in one convenient location shouldn't be complicated. The team at the Stahlheber Rd. location in Hamilton, OH can answer all of your questions and help you complete your transactions quickly and without hassle. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. The team looks forward to meeting you, so stop by today and experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 39.4209446,
    "lng": -84.5910332,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-895-2100",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742638,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "16MTaE8YSP.jpeg",
        "locationId": 3365619,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365619/16MTaE8YSP.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365619/medium_16MTaE8YSP.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365619/thumb_16MTaE8YSP.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365619/p6LByoEhVu.jpeg"
      }
    ],
    "keywords": [
      "check cashing hamilton",
      "checksmart hamilton",
      "line of credit hamilton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:29.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 176,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25938",
    "id": 3365620,
    "dateCreated": "2022-05-31T13:24:30.000+02:00",
    "lastUpdated": "2025-06-03T23:31:55.000+02:00",
    "name": "CheckSmart",
    "street": "Euclid Avenue",
    "streetNo": "34302",
    "streetAndNumber": "34302 Euclid Avenue",
    "addressExtra": null,
    "zip": "44094",
    "city": "Willoughby",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/willoughby/34302-euclid-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "At CheckSmart, we know that when you are busy and have financial services transactions on your mile long to-do list, you need a great team to help you quickly and in a convenient location. Stop by the Euclid Avenue location of Check Smart in Willoughby, OH to experience the CheckSmart difference. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team wants to help answer all of your questions, so don't hesitate to reach out or pop by today. We'll have you back to business in no time at all!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 41.6234778,
    "lng": -81.4442931,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 440-602-9922",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742674,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "ctRlXGpsYZ.jpeg",
        "locationId": 3365620,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365620/ctRlXGpsYZ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365620/medium_ctRlXGpsYZ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365620/thumb_ctRlXGpsYZ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365620/1qs3KvCS65.jpeg"
      }
    ],
    "keywords": [
      "check cashing willoughby",
      "checksmart willoughby",
      "line of credit willoughby"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:30.000+02:00",
    "averageRating": 5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 330,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21238",
    "id": 3365621,
    "dateCreated": "2022-05-31T13:24:31.000+02:00",
    "lastUpdated": "2025-06-04T11:58:24.000+02:00",
    "name": "CheckSmart",
    "street": "Warsaw Avenue",
    "streetNo": "3441",
    "streetAndNumber": "3441 Warsaw Avenue",
    "addressExtra": null,
    "zip": "45205",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/3441-warsaw-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you are looking for a one-stop-shop for all of your financial services needs, CheckSmart has you covered. The team at the store on Warsaw Ave. in Cincinnati, OH can answer any questions you may have and will help you complete your transaction quickly so you can get back to your day! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team will work hard to make the process as convenient as possible. That's the CheckSmart way!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 39.1099927,
    "lng": -84.567626,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-471-0548",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742675,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "YafD7YXXuM.jpeg",
        "locationId": 3365621,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365621/YafD7YXXuM.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365621/medium_YafD7YXXuM.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365621/thumb_YafD7YXXuM.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365621/CltKQvUYft.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:31.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 203,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20838",
    "id": 3365622,
    "dateCreated": "2022-05-31T13:24:32.000+02:00",
    "lastUpdated": "2025-06-04T11:52:41.000+02:00",
    "name": "CheckSmart",
    "street": "Harrison Avenue",
    "streetNo": "10701",
    "streetAndNumber": "10701 Harrison Avenue",
    "addressExtra": null,
    "zip": "45030",
    "city": "Harrison",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/harrison/10701-harrison-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need to access financial services you can count on look no further than CheckSmart! Our Harrison Avenue location in Harrison, OH is ready to help and will have you on your way in no time at all. We know life is busy, so let us help check items off your to-do list quickly and without hassle. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Convenience and customer service are our two top priorities at CheckSmart, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 39.2535479,
    "lng": -84.7968793,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-202-1900",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742679,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "KACWwnb6HB.jpeg",
        "locationId": 3365622,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365622/KACWwnb6HB.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365622/medium_KACWwnb6HB.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365622/thumb_KACWwnb6HB.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365622/mhvEYAK6Oc.jpeg"
      }
    ],
    "keywords": [
      "check cashing harrison",
      "checksmart harrison",
      "line of credit harrison"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:32.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 871,
    "dataPoints": 106,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26138",
    "id": 3365624,
    "dateCreated": "2022-05-31T13:24:33.000+02:00",
    "lastUpdated": "2025-06-03T23:31:55.000+02:00",
    "name": "CheckSmart",
    "street": "Turney Road",
    "streetNo": "5062",
    "streetAndNumber": "5062 Turney Road",
    "addressExtra": null,
    "zip": "44125",
    "city": "Garfield Heights",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/garfield-heights/5062-turney-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "The team at CheckSmart knows that convenience matters and that your time is valuable. When you need to complete a financial services related transaction quickly the Turney Rd. location in Garfield Heights, OH can help. Our team can offer an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Work with our team of experts and experience the CheckSmart difference today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 41.42316878,
    "lng": -81.6110639,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 216-587-5631",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742640,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "eOFd9m4sIp.jpeg",
        "locationId": 3365624,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365624/eOFd9m4sIp.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365624/medium_eOFd9m4sIp.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365624/thumb_eOFd9m4sIp.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365624/zNSeq62GSQ.jpeg"
      }
    ],
    "keywords": [
      "check cashing garfield heights",
      "checksmart garfield heights",
      "line of credit garfield heights"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:33.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 856,
    "dataPoints": 242,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "24638",
    "id": 3365626,
    "dateCreated": "2022-05-31T13:24:35.000+02:00",
    "lastUpdated": "2025-06-04T11:53:17.000+02:00",
    "name": "CheckSmart",
    "street": "Sawmill Road",
    "streetNo": "7370",
    "streetAndNumber": "7370 Sawmill Road",
    "addressExtra": null,
    "zip": "43235",
    "city": "Columbus",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/columbus/7370-sawmill-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need quick and convenient service, CheckSmart is in your corner. Stop by the Sawmill Road location in Columbus, OH to work with our team and you'll be on your way in no time at all. Our store offers a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. We work hard to provide our customers with top notch service every time they walk through our doors, so stop by today to experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:03.000+02:00",
    "country": "US",
    "lat": 40.1162109,
    "lng": -83.0895679,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-764-1110",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742651,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "DXYvpCDq01.jpeg",
        "locationId": 3365626,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365626/DXYvpCDq01.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365626/medium_DXYvpCDq01.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365626/thumb_DXYvpCDq01.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365626/jgkAYj1xVo.jpeg"
      }
    ],
    "keywords": [
      "check cashing columbus",
      "checksmart columbus",
      "line of credit columbus"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:34.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 852,
    "dataPoints": 186,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20938",
    "id": 3365628,
    "dateCreated": "2022-05-31T13:24:40.000+02:00",
    "lastUpdated": "2025-06-04T12:21:16.000+02:00",
    "name": "CheckSmart",
    "street": "Galbraith Road",
    "streetNo": "2003",
    "streetAndNumber": "2003 Galbraith Road",
    "addressExtra": null,
    "zip": "45239",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/2003-galbraith-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you want to work with a fantastic team, choose CheckSmart. Our team on Galbraith Road in Cincinnati, OH can help you complete various financial services and will have you on your way, back to life, as quickly as possible.Our store offers a wide array of financial services includingC heck Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. We're here to help when you need us, so please don't hesitate to reach out with questions! Experience the CheckSmart difference the next time you have one of our services on your to-do list!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.21812932,
    "lng": -84.56038972,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-931-7300",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742661,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "N6NvCCtJ23.jpeg",
        "locationId": 3365628,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365628/N6NvCCtJ23.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365628/medium_N6NvCCtJ23.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365628/thumb_N6NvCCtJ23.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365628/bFU8gGZzOo.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:40.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 864,
    "dataPoints": 181,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21438",
    "id": 3365630,
    "dateCreated": "2022-05-31T13:24:42.000+02:00",
    "lastUpdated": "2025-06-02T20:32:09.000+02:00",
    "name": "CheckSmart",
    "street": "South Limestone Street",
    "streetNo": "2000",
    "streetAndNumber": "2000 South Limestone Street",
    "addressExtra": null,
    "zip": "45505",
    "city": "Springfield",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/springfield/2000-south-limestone-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need a team dedicated to great customer service, stop by CheckSmart. Our location in Springfield, OH on Limestone St. is conveniently located and the team can offer financial services you can count on. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. CheckSmart is dedicated to helping our clients, so stop by today to learn more! We're here to help and we make sure the process is hassle free when you choose CheckSmart.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.8995,
    "lng": -83.81069,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-324-9111",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742646,
        "dateCreated": "2025-04-17T16:23:26.000+02:00",
        "repoKey": "TMJSv0qxbA.jpeg",
        "locationId": 3365630,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365630/TMJSv0qxbA.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365630/medium_TMJSv0qxbA.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365630/thumb_TMJSv0qxbA.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365630/2Boh7l30Dj.jpeg"
      }
    ],
    "keywords": [
      "check cashing springfield",
      "checksmart springfield",
      "line of credit springfield"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:42.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 98,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21138",
    "id": 3365631,
    "dateCreated": "2022-05-31T13:24:43.000+02:00",
    "lastUpdated": "2025-06-04T12:18:10.000+02:00",
    "name": "CheckSmart",
    "street": "Colerain Avenue",
    "streetNo": "9385",
    "streetAndNumber": "9385 Colerain Avenue",
    "addressExtra": null,
    "zip": "45251",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/9385-colerain-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need to quickly complete a financial services transaction, we know that convenience is extremely important. That's why the CheckSmart team at the Coleraine Avenue location in Cincinnati, OH is always standing by to help get you in and out of the store quickly and without hassle. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team works hard to make things as convenient as possible for our customers, so stop by today and experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.241852,
    "lng": -84.59475816,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-741-3777",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742656,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "b47TJltqTt.jpeg",
        "locationId": 3365631,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365631/b47TJltqTt.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365631/medium_b47TJltqTt.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365631/thumb_b47TJltqTt.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365631/nv8UttBHgR.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:43.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 201,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25838",
    "id": 3365633,
    "dateCreated": "2022-05-31T13:24:45.000+02:00",
    "lastUpdated": "2025-06-03T23:31:55.000+02:00",
    "name": "CheckSmart",
    "street": "Delaware Avenue",
    "streetNo": "842",
    "streetAndNumber": "842 Delaware Avenue",
    "addressExtra": null,
    "zip": "43040",
    "city": "Marysville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/marysville/842-delaware-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you're busy and have a lot to do, convenience is key. CheckSmart on Delaware Avenue in Marysville, OH offers a wide range of services quickly and without any hassle. Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Your life is moving quickly, allow our team to keep things moving for you. We'll have you in and out of the store in record time, and quality customer service will always remain our top priority!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 40.2366047,
    "lng": -83.35515421,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-642-1664",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742670,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "osWwCFHOkh.jpeg",
        "locationId": 3365633,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365633/osWwCFHOkh.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365633/medium_osWwCFHOkh.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365633/thumb_osWwCFHOkh.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365633/CDB84kfjkE.jpeg"
      }
    ],
    "keywords": [
      "check cashing marysville",
      "checksmart marysville",
      "line of credit marysville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:45.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 875,
    "dataPoints": 70,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26738",
    "id": 3365634,
    "dateCreated": "2022-05-31T13:24:46.000+02:00",
    "lastUpdated": "2025-06-04T12:19:27.000+02:00",
    "name": "CheckSmart",
    "street": "West 117th Street",
    "streetNo": "1508",
    "streetAndNumber": "1508 West 117th Street",
    "addressExtra": null,
    "zip": "44107",
    "city": "Lakewood",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/lakewood/1508-west-117th-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Once you've experienced the CheckSmart difference, you'll know you've found your go-to financial services provider in Lakewood, OH. Stop by the store on 117th Street to connect with our exceptional team. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. The team looks forward to answering all of your questions and will work hard to make the process as convenient as possible because we know you're a busy bee and time is precious. We'll have you in and out and on your way quickly and without hassle.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 41.4800975,
    "lng": -81.7692446,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 216-226-4066",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742660,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "WHsWWQ71ro.jpeg",
        "locationId": 3365634,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365634/WHsWWQ71ro.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365634/medium_WHsWWQ71ro.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365634/thumb_WHsWWQ71ro.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365634/W2klK4Mmzq.jpeg"
      }
    ],
    "keywords": [
      "check cashing lakewood",
      "checksmart lakewood",
      "line of credit lakewood"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:45.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 851,
    "dataPoints": 131,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20138",
    "id": 3365635,
    "dateCreated": "2022-05-31T13:24:47.000+02:00",
    "lastUpdated": "2025-06-03T23:31:55.000+02:00",
    "name": "CheckSmart",
    "street": "Business 28",
    "streetNo": "932",
    "streetAndNumber": "932 Business 28",
    "addressExtra": null,
    "zip": "45150",
    "city": "Milford",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/milford/932-business-28/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "If you need to check financial services items off your to-do list, CheckSmart has you covered. Stop by the store at 932 A. St. in Milford, OH to speak with the team and they will help you complete your transactions quickly and without hassle. You'll be on your way in no time at all! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We strive to provide excellent customer service to everyone who walks through our doors. Experience the CheckSmart difference for yourself, stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.1918749,
    "lng": -84.2520405,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-831-4455",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742664,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "BxLt7FVORd.jpeg",
        "locationId": 3365635,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365635/BxLt7FVORd.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365635/medium_BxLt7FVORd.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365635/thumb_BxLt7FVORd.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365635/Jb6rq14DV1.jpeg"
      }
    ],
    "keywords": [
      "check cashing milford",
      "checksmart milford",
      "line of credit milford"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:46.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 91,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20238",
    "id": 3365637,
    "dateCreated": "2022-05-31T13:24:48.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Ohio Pike",
    "streetNo": "637",
    "streetAndNumber": "637 Ohio Pike",
    "addressExtra": null,
    "zip": "45245",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/637-ohio-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Completing the financial services tasks on your to-do list shouldn't be complicated, and that's why CheckSmart works hard to provide options to our customers as conveniently and quickly as possible. Stop by the Ohio Pike store in Cincinnati, OH today to experience the CheckSmart difference. We offer various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Customer service is our focus at CheckSmart, so allow us to be your go-to one-stop-shop!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.0647336,
    "lng": -84.2924329,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-947-9551",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742682,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "JjvTwAtOnW.jpeg",
        "locationId": 3365637,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365637/JjvTwAtOnW.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365637/medium_JjvTwAtOnW.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365637/thumb_JjvTwAtOnW.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365637/NyMzcPMboA.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:48.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 102,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26038",
    "id": 3365639,
    "dateCreated": "2022-05-31T13:24:50.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Brookpark Road",
    "streetNo": "2196",
    "streetAndNumber": "2196 Brookpark Road",
    "addressExtra": null,
    "zip": "44134",
    "city": "Cleveland",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cleveland/2196-brookpark-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is your go-to financial services provider in Cleveland, OH. Stop by the Brookpark Road location to connect with our team and to complete your transactions today! Our store offers a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Check Smart works hard to make things work for you, and creating experiences that customers rave about is always our goal. We're here to help you quickly, efficiently, and without a hassle. Pop by to meet the team and experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 41.4199797,
    "lng": -81.6970797,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 216-351-3366",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742692,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "aeSIcJDf7N.jpeg",
        "locationId": 3365639,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365639/aeSIcJDf7N.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365639/medium_aeSIcJDf7N.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365639/thumb_aeSIcJDf7N.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365639/5xN00xvOLe.jpeg"
      }
    ],
    "keywords": [
      "check cashing cleveland",
      "checksmart cleveland",
      "line of credit cleveland"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:49.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 222,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22238",
    "id": 3365641,
    "dateCreated": "2022-05-31T13:24:51.000+02:00",
    "lastUpdated": "2025-06-04T12:08:42.000+02:00",
    "name": "CheckSmart",
    "street": "Old Troy Pike",
    "streetNo": "7687",
    "streetAndNumber": "7687 Old Troy Pike",
    "addressExtra": null,
    "zip": "45424",
    "city": "Huber Heights",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/huber-heights/7687-old-troy-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "At CheckSmart, convenience and quick service are our top priority. Stop by the Old Troy PK location in Huber Heights, OH tooday! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team will work hard to ensure you have an exceptional experience in store. So the next time you have a mile long to-do list that includes financial services, pop by CheckSmart your one-stop-shop!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:02.000+02:00",
    "country": "US",
    "lat": 39.86519319,
    "lng": -84.14054522,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-236-4988",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742691,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "LvzRkCgDmR.jpeg",
        "locationId": 3365641,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365641/LvzRkCgDmR.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365641/medium_LvzRkCgDmR.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365641/thumb_LvzRkCgDmR.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365641/aco0oGh6Kb.jpeg"
      }
    ],
    "keywords": [
      "check cashing huber heights",
      "checksmart huber heights",
      "line of credit huber heights"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:51.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 862,
    "dataPoints": 80,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21538",
    "id": 3365642,
    "dateCreated": "2022-05-31T13:24:52.000+02:00",
    "lastUpdated": "2025-06-04T12:08:07.000+02:00",
    "name": "CheckSmart",
    "street": "Linden Avenue",
    "streetNo": "4212",
    "streetAndNumber": "4212 Linden Avenue",
    "addressExtra": null,
    "zip": "45432",
    "city": "Dayton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/dayton/4212-linden-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to financial services on the spot is crucial when you're in a pinch, and CheckSmart is here to help. Stop by the Linden Avenue location in Dayton, OH to discuss your options with our team.  Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our goal is to provide exceptional customer services you can count on, so stop by the store today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.74345,
    "lng": -84.11996,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-254-7800",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742700,
        "dateCreated": "2025-04-17T16:23:31.000+02:00",
        "repoKey": "Z3jtjsqFsK.jpeg",
        "locationId": 3365642,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365642/Z3jtjsqFsK.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365642/medium_Z3jtjsqFsK.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365642/thumb_Z3jtjsqFsK.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365642/V4D5k9IwZE.jpeg"
      }
    ],
    "keywords": [
      "check cashing dayton",
      "checksmart dayton",
      "line of credit dayton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:52.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 188,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "24238",
    "id": 3365643,
    "dateCreated": "2022-05-31T13:24:52.000+02:00",
    "lastUpdated": "2025-06-03T12:12:03.000+02:00",
    "name": "CheckSmart",
    "street": "North Wilson Road",
    "streetNo": "170",
    "streetAndNumber": "170 North Wilson Road",
    "addressExtra": null,
    "zip": "43204",
    "city": "Columbus",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/columbus/170-north-wilson-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "The CheckSmart team at the N. Wilson Road location in Columbus, OH is here to help when you need access to financial services you can count on. Our store offers various services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Let our team offer assistance when you're in need of asssitance with cash services, stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.95777,
    "lng": -83.09229,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-276-3334",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742689,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "64WXJ5XXZ3.jpeg",
        "locationId": 3365643,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365643/64WXJ5XXZ3.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365643/medium_64WXJ5XXZ3.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365643/thumb_64WXJ5XXZ3.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365643/LTEQZJ4Z1Q.jpeg"
      }
    ],
    "keywords": [
      "check cashing columbus",
      "checksmart columbus",
      "line of credit columbus"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:52.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 136,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20738",
    "id": 3365646,
    "dateCreated": "2022-05-31T13:24:54.000+02:00",
    "lastUpdated": "2025-06-04T10:25:33.000+02:00",
    "name": "CheckSmart",
    "street": "Dixie Highway",
    "streetNo": "6580",
    "streetAndNumber": "6580 Dixie Highway",
    "addressExtra": "A",
    "zip": "45014",
    "city": "Fairfield",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/fairfield/6580-dixie-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you are checking errands off your to-do list and need to complete a few financial services tasks, CheckSmart has you covered in a convenient one-stop-shop. Stop by the Dixie Highway location in Fairfield, OH to connect with our team and today! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Exceptional customer service and a team you can trust just around the corner at CheckSmart!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.32003,
    "lng": -84.49738,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-942-9977",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742690,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "t02uQDdka8.jpeg",
        "locationId": 3365646,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365646/t02uQDdka8.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365646/medium_t02uQDdka8.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365646/thumb_t02uQDdka8.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365646/Ouxpeg4xjN.jpeg"
      }
    ],
    "keywords": [
      "check cashing fairfield",
      "checksmart fairfield",
      "line of credit fairfield"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:54.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 864,
    "dataPoints": 187,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22138",
    "id": 3365645,
    "dateCreated": "2022-05-31T13:24:54.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Salem Avenue",
    "streetNo": "5521",
    "streetAndNumber": "5521 Salem Avenue",
    "addressExtra": null,
    "zip": "45426",
    "city": "Dayton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/dayton/5521-salem-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Interested in working with a team that has your back? Look no further than the CheckSmart store on Salem Avenue in Dayton, OH. We're your go-to financial services store. We offer a wide variety of services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We can help you get in the store and on your way quickly and without hassle, so stop by the next time your list of errands includes cash services like those found at CheckSmart.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.82442422,
    "lng": -84.29023023,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-854-3392",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742685,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "NEemJXwwXu.jpeg",
        "locationId": 3365645,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365645/NEemJXwwXu.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365645/medium_NEemJXwwXu.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365645/thumb_NEemJXwwXu.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365645/K48RA8Bd9D.jpeg"
      }
    ],
    "keywords": [
      "check cashing dayton",
      "checksmart dayton",
      "line of credit dayton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:53.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 154,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23738",
    "id": 3365647,
    "dateCreated": "2022-05-31T13:24:55.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Hebron Road",
    "streetNo": "801",
    "streetAndNumber": "801 Hebron Road",
    "addressExtra": null,
    "zip": "43056",
    "city": "Heath",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/heath/801-hebron-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need to complete the financial service items on your to-do list in a convenient location and want to work with a great team of experts, stop by CheckSmart! Our team in the store on Hebron Road in Heath, OH is standing by and ready to help you complete your transactions quickly and easily. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We are here for you when you need us, so don't hesitate to reach out with any questions you may have!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 40.02999,
    "lng": -82.44156,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-788-8631",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742688,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "bZITeWddSE.jpeg",
        "locationId": 3365647,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365647/bZITeWddSE.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365647/medium_bZITeWddSE.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365647/thumb_bZITeWddSE.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365647/aD13MFQq0X.jpeg"
      }
    ],
    "keywords": [
      "check cashing heath",
      "checksmart heath",
      "line of credit heath"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:55.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 125,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25238",
    "id": 3365649,
    "dateCreated": "2022-05-31T13:24:56.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Youngstown Warren Road",
    "streetNo": "5700",
    "streetAndNumber": "5700 Youngstown Warren Road",
    "addressExtra": null,
    "zip": "44446",
    "city": "Niles",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/niles/5700-youngstown-warren-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Connect with the team at the Niles, OH CheckSmart store on Youngstown-Warren Rd. to learn more about the convenient financial services we have available! Our store offers a wide range of services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to customer service, so stop by today to handle all of your financial services transactions in one fantastic spot!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 41.2094755,
    "lng": -80.74987659,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 330-544-6017",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742695,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "jQ1CHnEYHg.jpeg",
        "locationId": 3365649,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365649/jQ1CHnEYHg.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365649/medium_jQ1CHnEYHg.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365649/thumb_jQ1CHnEYHg.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365649/lkOc6IlKKq.jpeg"
      }
    ],
    "keywords": [
      "check cashing niles",
      "checksmart niles",
      "line of credit niles"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:56.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 291,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23638",
    "id": 3365650,
    "dateCreated": "2022-05-31T13:24:57.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "East Dublin Granville Road",
    "streetNo": "1624",
    "streetAndNumber": "1624 East Dublin Granville Road",
    "addressExtra": null,
    "zip": "43229",
    "city": "Columbus",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/columbus/1624-east-dublin-granville-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Financial services in a convenient location are available to you at CheckSmart. Stop by the Morse Road location in Columbus, OH to connect with the team and learn more about your options. Our store offers a wide variety of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. When you need to pop in and out to take care of an item on your to-do list without a hassle, CheckSmart is here to help. Please don't hesitate to reach out with any questions! Our goal is to be your go-to neighborhood stop for all of your financial service needs.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 40.0883727,
    "lng": -82.9746481,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-882-2217",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742701,
        "dateCreated": "2025-04-17T16:23:31.000+02:00",
        "repoKey": "ML22wUFxHp.jpeg",
        "locationId": 3365650,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365650/ML22wUFxHp.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365650/medium_ML22wUFxHp.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365650/thumb_ML22wUFxHp.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365650/ClNHpVuUlT.jpeg"
      }
    ],
    "keywords": [
      "check cashing columbus",
      "checksmart columbus",
      "line of credit columbus"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:57.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 153,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23938",
    "id": 3365651,
    "dateCreated": "2022-05-31T13:24:58.000+02:00",
    "lastUpdated": "2025-06-04T10:20:51.000+02:00",
    "name": "CheckSmart",
    "street": "McMahan Boulevard",
    "streetNo": "134",
    "streetAndNumber": "134 McMahan Boulevard",
    "addressExtra": null,
    "zip": "43302",
    "city": "Marion",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/marion/134-mcmahan-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart in Marion, OH on McMahan Blvd. is here to help when you have a range of financial services transactions on your to-do list. Our store offers a wide range services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is committed to providing excellent customer serice, and we'll have you on your way in no time at all. We know that when you're busy, convenience is key!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 40.5819109,
    "lng": -83.0821263,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-389-2097",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742698,
        "dateCreated": "2025-04-17T16:23:31.000+02:00",
        "repoKey": "08nWTz0tfn.jpeg",
        "locationId": 3365651,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365651/08nWTz0tfn.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365651/medium_08nWTz0tfn.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365651/thumb_08nWTz0tfn.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365651/yiiWkTT6DT.jpeg"
      }
    ],
    "keywords": [
      "check cashing marion",
      "checksmart marion",
      "line of credit marion"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:57.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 152,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21838",
    "id": 3365653,
    "dateCreated": "2022-05-31T13:24:59.000+02:00",
    "lastUpdated": "2025-06-04T10:22:28.000+02:00",
    "name": "CheckSmart",
    "street": "West Alex Bell Road",
    "streetNo": "2930",
    "streetAndNumber": "2930 West Alex Bell Road",
    "addressExtra": null,
    "zip": "45459",
    "city": "Dayton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/dayton/2930-west-alex-bell-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Convenient completion of all of your financial services transactions isn't complicated when you work with the team at CheckSmart. Visit our Dayton, OH location on Alex Bell Rd. to learn more about the services that are available including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to providing excellent customer experiences, so pop by today to connect with our wonderful team!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.6726901,
    "lng": -84.2206752,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-428-7530",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742702,
        "dateCreated": "2025-04-17T16:23:31.000+02:00",
        "repoKey": "HhHORWm2JW.jpeg",
        "locationId": 3365653,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365653/HhHORWm2JW.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365653/medium_HhHORWm2JW.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365653/thumb_HhHORWm2JW.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365653/W8wFzoZrsB.jpeg"
      }
    ],
    "keywords": [
      "check cashing dayton",
      "checksmart dayton",
      "line of credit dayton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:59.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 126,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25638",
    "id": 3365654,
    "dateCreated": "2022-05-31T13:25:00.000+02:00",
    "lastUpdated": "2025-06-04T10:18:00.000+02:00",
    "name": "CheckSmart",
    "street": "Westpointe Plaza Drive",
    "streetNo": "5327",
    "streetAndNumber": "5327 Westpointe Plaza Drive",
    "addressExtra": null,
    "zip": "43228",
    "city": "Columbus",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/columbus/5327-westpointe-plaza-drive/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart offers financial services solutions that fit our customers' unique needs. Stop by the West Pointe Plaza location in Columbus, OH to chat with a team member. We offer multiple financial services in store such as Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. We work hard to make the process as simple and convenient as possible, so stop by CheckSmart and you'll be on your way in no time at all.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.98273713,
    "lng": -83.1493214,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-527-4444",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742706,
        "dateCreated": "2025-04-17T16:23:48.000+02:00",
        "repoKey": "QyG1H977Wm.jpeg",
        "locationId": 3365654,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365654/QyG1H977Wm.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365654/medium_QyG1H977Wm.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365654/thumb_QyG1H977Wm.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365654/tkSIMGRFHA.jpeg"
      }
    ],
    "keywords": [
      "check cashing columbus",
      "checksmart columbus",
      "line of credit columbus"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:24:59.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 89,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "24538",
    "id": 3365656,
    "dateCreated": "2022-05-31T13:25:01.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "Linden Avenue",
    "streetNo": "1069",
    "streetAndNumber": "1069 Linden Avenue",
    "addressExtra": null,
    "zip": "43701",
    "city": "Zanesville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/zanesville/1069-linden-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Visit CheckSmart to experience exceptional customer service in our one-stop-shop for all of your financial services needs. Our team at the Linden Avenue location in Zanesville, OH is always here to help get you in and out and on your way quickly and without hassle. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. The CheckSmart team works hard to make the process convenient and efficient!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 39.95168961,
    "lng": -82.00766565,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-450-7720",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742594,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "11CQM8BvZt.jpeg",
        "locationId": 3365656,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365656/11CQM8BvZt.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365656/medium_11CQM8BvZt.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365656/thumb_11CQM8BvZt.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365656/qOyCuiqLsm.jpeg"
      }
    ],
    "keywords": [
      "check cashing zanesville",
      "checksmart zanesville",
      "line of credit zanesville"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:01.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 858,
    "dataPoints": 135,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25738",
    "id": 3365655,
    "dateCreated": "2022-05-31T13:25:01.000+02:00",
    "lastUpdated": "2025-06-03T23:31:56.000+02:00",
    "name": "CheckSmart",
    "street": "East Main Street",
    "streetNo": "7113",
    "streetAndNumber": "7113 East Main Street",
    "addressExtra": null,
    "zip": "43068",
    "city": "Reynoldsburg",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/reynoldsburg/7113-east-main-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need to be in and out of the store to complete the financial services items on your to-do list, CheckSmart is here to help. Visit the team on E. Main Street in Reynoldsburg, OH today to get rolling. Our store offers an array of financial services to meet your needs including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Check Smart is offering smart solutions that work for our clients quickly and in a convenient location. Stop by to experience the CheckSmart difference today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:01.000+02:00",
    "country": "US",
    "lat": 39.9547597,
    "lng": -82.80753949,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-751-1314",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742704,
        "dateCreated": "2025-04-17T16:23:33.000+02:00",
        "repoKey": "JZWUqUN07Z.jpeg",
        "locationId": 3365655,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365655/JZWUqUN07Z.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365655/medium_JZWUqUN07Z.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365655/thumb_JZWUqUN07Z.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365655/bPcliwt7d8.jpeg"
      }
    ],
    "keywords": [
      "check cashing reynoldsburg",
      "checksmart reynoldsburg",
      "line of credit reynoldsburg"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:00.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 332,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25338",
    "id": 3365658,
    "dateCreated": "2022-05-31T13:25:03.000+02:00",
    "lastUpdated": "2025-06-04T10:19:07.000+02:00",
    "name": "CheckSmart",
    "street": "West Tuscarawas Avenue",
    "streetNo": "4408",
    "streetAndNumber": "4408 West Tuscarawas Avenue",
    "addressExtra": null,
    "zip": "44708",
    "city": "Canton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/canton/4408-west-tuscarawas-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you have multiple financial services transactions on your to-do list, CheckSmart on Tuscarawas Ave. in Canton, OH can help. Our conveniently located store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. Don't hesitate to reach out with any questions because our team is dedicated to creating exceptional experiences for all of our customers. Stop by to experience the CheckSmart way today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 40.79592639,
    "lng": -81.42677387,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 330-477-7867",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742591,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "A1NBZ9wOqH.jpeg",
        "locationId": 3365658,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365658/A1NBZ9wOqH.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365658/medium_A1NBZ9wOqH.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365658/thumb_A1NBZ9wOqH.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365658/AfqFlE6y9a.jpeg"
      }
    ],
    "keywords": [
      "check cashing canton",
      "checksmart canton",
      "line of credit canton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:03.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 564,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26538",
    "id": 3365659,
    "dateCreated": "2022-05-31T13:25:04.000+02:00",
    "lastUpdated": "2025-06-04T10:13:26.000+02:00",
    "name": "CheckSmart",
    "street": "North Ridge Road",
    "streetNo": "2193",
    "streetAndNumber": "2193 North Ridge Road",
    "addressExtra": "E",
    "zip": "44055",
    "city": "Elyria",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/elyria/2193-north-ridge-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to financial services and you want to work with a team dedicated to customer service, look no further than your neighborhood CheckSmart in Lorain, OH on North Ridge Rd E. Our team will answer all of your questions and have you on your way and back to your busy day in no time at all. Our store offers an array of services including Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is here to help, so don't hesitate to reach out with questions before popping by the store.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 41.41905475,
    "lng": -82.11998457,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 440-363-4288",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742600,
        "dateCreated": "2025-04-17T16:23:18.000+02:00",
        "repoKey": "234XBV4YUg.jpeg",
        "locationId": 3365659,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365659/234XBV4YUg.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365659/medium_234XBV4YUg.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365659/thumb_234XBV4YUg.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365659/lADBYRD0hW.jpeg"
      }
    ],
    "keywords": [
      "check cashing elyria",
      "checksmart elyria",
      "line of credit elyria"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:03.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 887,
    "dataPoints": 109,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23338",
    "id": 3365661,
    "dateCreated": "2022-05-31T13:25:05.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Morse Road",
    "streetNo": "2496",
    "streetAndNumber": "2496 Morse Road",
    "addressExtra": null,
    "zip": "43231",
    "city": "Columbus",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/columbus/2496-morse-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Financial services in a convenient location are available to you at CheckSmart. Stop by the Morse Road location in Columbus, OH to connect with the team and learn more about the options we have to offer. Our store provices exceptional customer service and can help you check the following items off your to-do list: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details.CheckSmart is here to help, so don't hesitate to reach out with any questions!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 40.05983,
    "lng": -82.9524033,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-478-4040",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742611,
        "dateCreated": "2025-04-17T16:23:22.000+02:00",
        "repoKey": "l5LgsD6aaZ.jpeg",
        "locationId": 3365661,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365661/l5LgsD6aaZ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365661/medium_l5LgsD6aaZ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365661/thumb_l5LgsD6aaZ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365661/65MfV9voSR.jpeg"
      }
    ],
    "keywords": [
      "check cashing columbus",
      "checksmart columbus",
      "line of credit columbus"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:05.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 854,
    "dataPoints": 362,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22538",
    "id": 3365662,
    "dateCreated": "2022-05-31T13:25:06.000+02:00",
    "lastUpdated": "2025-06-02T20:32:10.000+02:00",
    "name": "CheckSmart",
    "street": "Monroe Street",
    "streetNo": "4550",
    "streetAndNumber": "4550 Monroe Street",
    "addressExtra": null,
    "zip": "43613",
    "city": "Toledo",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/toledo/4550-monroe-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Look no further than the CheckSmart store on Monroe Street in Toledo, OH the next time you have financial services transactions on your to-do list. We're here to help and provide exceptional solutions for our customers. That's the CheckSmart way! Our store offers a wide range of financial services including: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Pop by the store for a customer service experience you can count on!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 41.6892378,
    "lng": -83.6213323,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 419-472-5007",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742601,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "TCD6lueMNp.jpeg",
        "locationId": 3365662,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365662/TCD6lueMNp.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365662/medium_TCD6lueMNp.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365662/thumb_TCD6lueMNp.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365662/A07Ss0mc2g.jpeg"
      }
    ],
    "keywords": [
      "check cashing toledo",
      "checksmart toledo",
      "line of credit toledo"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:06.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 193,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20538",
    "id": 3365664,
    "dateCreated": "2022-05-31T13:25:07.000+02:00",
    "lastUpdated": "2025-06-04T10:40:53.000+02:00",
    "name": "CheckSmart",
    "street": "East Ohio Pike",
    "streetNo": "1761",
    "streetAndNumber": "1761 East Ohio Pike",
    "addressExtra": null,
    "zip": "45102",
    "city": "Amelia",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ohio/amelia/1761-east-ohio-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to various financial services quickly and conveniently, CheckSmart is here to help. The team at the State Route 125 location in Amelia, OH is dedicated to creating exceptional customer experiences for everyone who walks through our doors! We offer a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Experience the CheckSmart difference for yourself, stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 39.01818714,
    "lng": -84.20206509,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-797-1600",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742619,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "xo27cV514K.jpeg",
        "locationId": 3365664,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365664/xo27cV514K.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365664/medium_xo27cV514K.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365664/thumb_xo27cV514K.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365664/U9QPGZ2HB7.jpeg"
      }
    ],
    "keywords": [
      "check cashing amelia",
      "checksmart amelia",
      "line of credit amelia"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:07.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 833,
    "dataPoints": 73,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21638",
    "id": 3365663,
    "dateCreated": "2022-05-31T13:25:07.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Dixie Highway",
    "streetNo": "3487",
    "streetAndNumber": "3487 Dixie Highway",
    "addressExtra": null,
    "zip": "45044",
    "city": "Middletown",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/middletown/3487-dixie-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, CheckSmart is here to help. Stop by the Dixie Highway location in Middletown, OH to learn more about our various financial services offered in store. Our store offers Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. We are working as hard as possible to help our clients when they need us most, so stop by today and experience the CheckSmart difference. We're dedicated to providing exceptional experiences for each person who walks through our doors.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 39.49574558,
    "lng": -84.3368998,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-727-4566",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742609,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "ltLxwBaqdC.jpeg",
        "locationId": 3365663,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365663/ltLxwBaqdC.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365663/medium_ltLxwBaqdC.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365663/thumb_ltLxwBaqdC.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365663/cxzVuAWmlQ.jpeg"
      }
    ],
    "keywords": [
      "check cashing middletown",
      "checksmart middletown",
      "line of credit middletown"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:06.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 222,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22838",
    "id": 3365665,
    "dateCreated": "2022-05-31T13:25:08.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Tiffin Avenue",
    "streetNo": "1216",
    "streetAndNumber": "1216 Tiffin Avenue",
    "addressExtra": null,
    "zip": "45840",
    "city": "Findlay",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/findlay/1216-tiffin-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to the financial services you need on the the spot is important, and CheckSmart is here to help. Our team at the Findlay, OH store on Tiffin Rd. will work hard to make sure your transactions go quickly and smoothly. Creating exceptional customer experiences is our passion! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Stop by the store to learn more today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 41.04990082,
    "lng": -83.6282798,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 419-424-3164",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742629,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "hnJN0d0qkI.jpeg",
        "locationId": 3365665,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365665/hnJN0d0qkI.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365665/medium_hnJN0d0qkI.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365665/thumb_hnJN0d0qkI.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365665/yJk3uD3UVG.jpeg"
      }
    ],
    "keywords": [
      "check cashing findlay",
      "checksmart findlay",
      "line of credit findlay"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:08.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 861,
    "dataPoints": 42,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20638",
    "id": 3365666,
    "dateCreated": "2022-05-31T13:25:10.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Glenway Avenue",
    "streetNo": "6582",
    "streetAndNumber": "6582 Glenway Avenue",
    "addressExtra": null,
    "zip": "45211",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/6582-glenway-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Looking for a conveniently located store to complete financial services transactions quicly and easily? Stop by the Check Smart store on Glenway Avenue in Cincinnati, OH. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Third party lending products available, contact store for details. We strive to provide exceptional customer service to every guest who walks through our doors, so don't hesitate to reach out with questions today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:27:00.000+02:00",
    "country": "US",
    "lat": 39.15573,
    "lng": -84.62864,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-598-9551",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742602,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "l5luvmSiBw.jpeg",
        "locationId": 3365666,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365666/l5luvmSiBw.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365666/medium_l5luvmSiBw.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365666/thumb_l5luvmSiBw.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365666/LLTZthgxG6.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:10.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 331,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22738",
    "id": 3365667,
    "dateCreated": "2022-05-31T13:25:11.000+02:00",
    "lastUpdated": "2025-06-02T20:32:10.000+02:00",
    "name": "CheckSmart",
    "street": "Milan Road",
    "streetNo": "4816",
    "streetAndNumber": "4816 Milan Road",
    "addressExtra": "Ste B",
    "zip": "44870",
    "city": "Sandusky",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/sandusky/4816-milan-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to financial services when you need them shouldn't be complicated, and at CheckSmart we're dedicated to making your transactions as convenient as possible. Stop by the store on Milan Rd. in Sandusky, OH to receive an outstanding customer experience. Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is here to help, so pop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 41.4101,
    "lng": -82.66492,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 419-625-3100",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742645,
        "dateCreated": "2025-04-17T16:23:26.000+02:00",
        "repoKey": "yy8jg7TPwE.jpeg",
        "locationId": 3365667,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365667/yy8jg7TPwE.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365667/medium_yy8jg7TPwE.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365667/thumb_yy8jg7TPwE.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365667/g7po6I9REY.jpeg"
      }
    ],
    "keywords": [
      "check cashing sandusky",
      "checksmart sandusky",
      "line of credit sandusky"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:10.000+02:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 888,
    "dataPoints": 58,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25138",
    "id": 3365669,
    "dateCreated": "2022-05-31T13:25:12.000+02:00",
    "lastUpdated": "2025-06-02T20:32:11.000+02:00",
    "name": "CheckSmart",
    "street": "W 130th St",
    "streetNo": "6895",
    "streetAndNumber": "6895 W 130th St",
    "addressExtra": null,
    "zip": "44130",
    "city": "Parma Heights",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/parma-heights/6895-w-130th-st/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is your go-to financial services provider when you want to work with an exceptional team. The team at the W 130th Street location in Parma Heights, OH will answer all of your questions before walking you through your transactions quickly and without a hassle. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Pop by today to experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 41.3772363,
    "lng": -81.783683,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 440-842-0426",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742678,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "xJb6jskhJ5.jpeg",
        "locationId": 3365669,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365669/xJb6jskhJ5.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365669/medium_xJb6jskhJ5.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365669/thumb_xJb6jskhJ5.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365669/ZaWaA9riLl.jpeg"
      }
    ],
    "keywords": [
      "check cashing heights",
      "checksmart heights",
      "payday loans heights"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:12.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 45,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22038",
    "id": 3365670,
    "dateCreated": "2022-05-31T13:25:13.000+02:00",
    "lastUpdated": "2025-05-31T14:32:22.000+02:00",
    "name": "CheckSmart",
    "street": "East Main Street",
    "streetNo": "2600",
    "streetAndNumber": "2600 East Main Street",
    "addressExtra": null,
    "zip": "45503",
    "city": "Springfield",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/springfield/2600-east-main-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to several financial services quickly and in one convenient location, stop by CheckSmart in Springfield, OH store on E. Main Street. We're standing by and ready to help! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We are dedicated to creating excellent customer services experiences, so stop by and let our team help!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.9237095,
    "lng": -83.7690628,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-325-4000",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742617,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "un19D97PsH.jpeg",
        "locationId": 3365670,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365670/un19D97PsH.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365670/medium_un19D97PsH.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365670/thumb_un19D97PsH.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365670/hJotairijq.jpeg"
      }
    ],
    "keywords": [
      "check cashing springfield",
      "checksmart springfield",
      "installment loans springfield",
      "payday loans springfield",
      "title loans springfield"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:13.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 841,
    "dataPoints": 97,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21938",
    "id": 3365671,
    "dateCreated": "2022-05-31T13:25:15.000+02:00",
    "lastUpdated": "2025-05-31T14:32:17.000+02:00",
    "name": "CheckSmart",
    "street": "Wilmington Pike",
    "streetNo": "4064",
    "streetAndNumber": "4064 Wilmington Pike",
    "addressExtra": null,
    "zip": "45440",
    "city": "Kettering",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/kettering/4064-wilmington-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart in Kettering, OH store on Wilmington Pike has a team standing by ready to help you complete all of your financial services transactions in one easy to access, convenient location. The team is dedicated to customer service and will help you get in and out and on your way in no time at all. Our store offers financial services including: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Pop by our store today to get the ball rolling and to access the services you need, conveniently!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.68731362,
    "lng": -84.12940445,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-294-0500",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742637,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "KxMkjTqxAs.jpeg",
        "locationId": 3365671,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365671/KxMkjTqxAs.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365671/medium_KxMkjTqxAs.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365671/thumb_KxMkjTqxAs.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365671/DG4tN14joJ.jpeg"
      }
    ],
    "keywords": [
      "check cashing kettering",
      "checksmart kettering",
      "line of credit kettering"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:14.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 858,
    "dataPoints": 123,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "27238",
    "id": 3365672,
    "dateCreated": "2022-05-31T13:25:16.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Euclid Avenue",
    "streetNo": "22641",
    "streetAndNumber": "22641 Euclid Avenue",
    "addressExtra": "# 5",
    "zip": "44117",
    "city": "Euclid",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/OH/Euclid/22641-euclid-ave-5/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": null,
    "descriptionLong": "CheckSmart is so much more than a check cashing store! Our team at the Euclid Ave. location in Euclid, OH can help complete your transactions quickly and easily. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to serving our customers, so stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-05-06T21:00:35.000+02:00",
    "country": "US",
    "lat": 41.57346574,
    "lng": -81.52405344,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 216-486-3434",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "keywords": [
      "check cashing euclid",
      "checksmart euclid",
      "line of credit euclid"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:16.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 88,
    "missingMandatoryFields": [
      "PHOTOS"
    ],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 831,
    "dataPoints": 278,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22638",
    "id": 3365673,
    "dateCreated": "2022-05-31T13:25:17.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Needmore Road",
    "streetNo": "2129",
    "streetAndNumber": "2129 Needmore Road",
    "addressExtra": null,
    "zip": "45414",
    "city": "Dayton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/dayton/2129-needmore-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Need access to several financial services at once? CheckSmart on Needmore Rd. in Dayton, OH is here to help, so stop by today to take care of all of your transactions in one convenient location! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Any questions you have will be answered by our team of dedicated customer service representatives, and we will help you get the ball rolling so you can be on your way as quickly as possible.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.82002511,
    "lng": -84.1948721,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 937-567-1450",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742610,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "gaIuLcm8yt.jpeg",
        "locationId": 3365673,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365673/gaIuLcm8yt.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365673/medium_gaIuLcm8yt.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365673/thumb_gaIuLcm8yt.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365673/qxvnq0Fe5q.jpeg"
      }
    ],
    "keywords": [
      "check cashing dayton",
      "checksmart dayton",
      "line of credit dayton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:16.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 71,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "24938",
    "id": 3365675,
    "dateCreated": "2022-05-31T13:25:18.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Pike Street",
    "streetNo": "234",
    "streetAndNumber": "234 Pike Street",
    "addressExtra": null,
    "zip": "45750",
    "city": "Marietta",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/marietta/234-pike-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is your go-to one-stop-shop for all of your financial services transactions. Need to cash a check and grab a money order? We've got you covered. Conveniently located on Pike Street in Marietta, OH our in-store team can help you and you'll be in and out in no time at all. Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Stop by today to learn more and to chat with the team about the wide range of services we provide!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.4136838,
    "lng": -81.4376858,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-374-6005",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742630,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "3L8XX6huMw.jpeg",
        "locationId": 3365675,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365675/3L8XX6huMw.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365675/medium_3L8XX6huMw.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365675/thumb_3L8XX6huMw.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365675/rIIncXBTxJ.jpeg"
      }
    ],
    "keywords": [
      "check cashing marietta",
      "checksmart marietta",
      "line of credit marietta"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:18.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 853,
    "dataPoints": 67,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21338",
    "id": 3365677,
    "dateCreated": "2022-05-31T13:25:19.000+02:00",
    "lastUpdated": "2025-05-31T14:32:22.000+02:00",
    "name": "CheckSmart",
    "street": "Reading Road",
    "streetNo": "8398",
    "streetAndNumber": "8398 Reading Road",
    "addressExtra": null,
    "zip": "45237",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/8398-reading-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need cash a check, grab a money order, or complete another financial services related task, you can count on CheckSmart. Our team at the Cincinnati, OH store on Reading Rd. offers an array of services in one convenient location. Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We work hard to create excellent customer services experiences for everyone who walks through our doors, so stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.21116993,
    "lng": -84.44727961,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-761-6003",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742631,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "XB8MPUTigs.jpeg",
        "locationId": 3365677,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365677/XB8MPUTigs.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365677/medium_XB8MPUTigs.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365677/thumb_XB8MPUTigs.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365677/vdieiOPUfZ.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati",
      "line of credit cincinnati"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:19.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 856,
    "dataPoints": 206,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "25438",
    "id": 3365679,
    "dateCreated": "2022-05-31T13:25:21.000+02:00",
    "lastUpdated": "2025-06-04T10:31:39.000+02:00",
    "name": "CheckSmart",
    "street": "Gypsy Lane",
    "streetNo": "663",
    "streetAndNumber": "663 Gypsy Lane",
    "addressExtra": null,
    "zip": "44504",
    "city": "Youngstown",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/youngstown/663-gypsy-lane/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to several financial services at once and you're not sure where to go to get things done as efficiently as possible, CheckSmart in Youngstown, OH store on Gypsy Lane has you covered! We aim to be your go-to one-stop-shop for all of your financial services needs! Our store offers an array of services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is dedicated to helping you each time you walk through our doors, so stop by to experience the CheckSmart difference today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 41.13263366,
    "lng": -80.66369908,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 330-743-1568",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742623,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "2jt75msagd.jpeg",
        "locationId": 3365679,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365679/2jt75msagd.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365679/medium_2jt75msagd.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365679/thumb_2jt75msagd.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365679/tbfQpqDny2.jpeg"
      }
    ],
    "keywords": [
      "check cashing youngstown",
      "checksmart youngstown",
      "line of credit youngstown"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:21.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 38,
    "listingsBeingUpdated": 14,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 865,
    "dataPoints": 164,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "27038",
    "id": 3365684,
    "dateCreated": "2022-05-31T13:25:24.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "South Arlington Street",
    "streetNo": "1287",
    "streetAndNumber": "1287 South Arlington Street",
    "addressExtra": null,
    "zip": "44306",
    "city": "Akron",
    "cellphone": null,
    "fax": "+1 330-785-3184",
    "website": "https://www.checksmart.com/store/OH/Akron/1287-south-arlington-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": null,
    "descriptionLong": "Access to multiple financial services in one convenient location shouldn't be complicated, and CheckSmart is here to help! The CheckSmart store in Akron, OH on Arlington Street offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team is here to help, so stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-05-14T23:45:31.000+02:00",
    "country": "US",
    "lat": 41.03696648,
    "lng": -81.49096876,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 330-785-3161",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "keywords": [
      "check cashing akron",
      "checksmart akron",
      "line of credit akron"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:24.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 88,
    "missingMandatoryFields": [
      "PHOTOS"
    ],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 825,
    "dataPoints": 215,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "24138",
    "id": 3365686,
    "dateCreated": "2022-05-31T13:25:26.000+02:00",
    "lastUpdated": "2025-06-04T10:59:26.000+02:00",
    "name": "CheckSmart",
    "street": "North Bridge Street",
    "streetNo": "860",
    "streetAndNumber": "860 North Bridge Street",
    "addressExtra": null,
    "zip": "45601",
    "city": "Chillicothe",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/chillicothe/860-north-bridge-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is so much more than your go-to check cashing store. Stop by the Chillicothe, OH location on N Bridge Street today to experience our signature, exceptional customer service for yourself. Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team works hard to make the process convenient and efficient!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:59.000+02:00",
    "country": "US",
    "lat": 39.3527567,
    "lng": -82.9770581,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-851-4073",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742643,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "RoXbOdf7L6.jpeg",
        "locationId": 3365686,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365686/RoXbOdf7L6.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365686/medium_RoXbOdf7L6.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365686/thumb_RoXbOdf7L6.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365686/CqI5T2tjli.jpeg"
      }
    ],
    "keywords": [
      "check cashing chillicothe",
      "checksmart chillicothe",
      "line of credit chillicothe"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:26.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 854,
    "dataPoints": 192,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "26338",
    "id": 3365687,
    "dateCreated": "2022-05-31T13:25:30.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "State Road",
    "streetNo": "2020",
    "streetAndNumber": "2020 State Road",
    "addressExtra": null,
    "zip": "44223",
    "city": "Cuyahoga Falls",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cuyahoga-falls/2020-state-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "The CheckSmart team at the State Road store in Cuyahoga, OH offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Our team works hard to provide convenience and exceptional service to each of our customers. When you want to work with a team you can count on and knock out several of your financial services transactions in one easy to access location, CheckSmart is your go-to store!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 41.13508713,
    "lng": -81.50892299,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 330-940-3271",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742658,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "GTqpSeVgRP.jpeg",
        "locationId": 3365687,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365687/GTqpSeVgRP.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365687/medium_GTqpSeVgRP.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365687/thumb_GTqpSeVgRP.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365687/gZEQOe6CR9.jpeg"
      }
    ],
    "keywords": [
      "check cashing cuyahoga falls",
      "checksmart cuyahoga falls",
      "line of credit cuyahoga falls"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:29.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 169,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "22938",
    "id": 3365688,
    "dateCreated": "2022-05-31T13:25:34.000+02:00",
    "lastUpdated": "2025-06-04T10:56:12.000+02:00",
    "name": "CheckSmart",
    "street": "Elida Road",
    "streetNo": "1980",
    "streetAndNumber": "1980 Elida Road",
    "addressExtra": null,
    "zip": "45805",
    "city": "Lima",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/OH/Lima/1980-elida-rd/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": null,
    "descriptionLong": "We're so much more than your go-to, conveniently located cash checking store! Stop by the Elida Rd. location of CheckSmart in Lima, OH to work with one of our dedicated team members. You'll be in and out in a flash! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Creating exceptional customer service experiences is our goal each time you walk through our doors, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-05-09T16:25:42.000+02:00",
    "country": "US",
    "lat": 40.7584711,
    "lng": -84.1392881,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 567-371-3497",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "keywords": [
      "check cashing lima",
      "checksmart lima",
      "line of credit lima"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:33.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 88,
    "missingMandatoryFields": [
      "PHOTOS"
    ],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 797,
    "dataPoints": 166,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23238",
    "id": 3365690,
    "dateCreated": "2022-05-31T13:25:41.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "Sunset Boulevard",
    "streetNo": "4420",
    "streetAndNumber": "4420 Sunset Boulevard",
    "addressExtra": null,
    "zip": "43952",
    "city": "Steubenville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/steubenville/4420-sunset-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is so much more than your favorite check cashing store. Stop by the Sunset Boulevard location of CheckSmart in Steubenville, OH to experience the difference a team that is dedicated to customer service can make! Your convenience is our priority. Our store offers a wide range of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We strive to offer exceptional service to everyone who walks through our door, so please stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 40.3723403,
    "lng": -80.6822354,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-275-4075",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742636,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "X3yu6Pb2ku.jpeg",
        "locationId": 3365690,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365690/X3yu6Pb2ku.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365690/medium_X3yu6Pb2ku.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365690/thumb_X3yu6Pb2ku.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365690/TThkRaOSyY.jpeg"
      }
    ],
    "keywords": [
      "check cashing steubenville",
      "checksmart steubenville",
      "line of credit steubenville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:41.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 857,
    "dataPoints": 247,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23138",
    "id": 3365691,
    "dateCreated": "2022-05-31T13:25:45.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "National Road",
    "streetNo": "906",
    "streetAndNumber": "906 National Road",
    "addressExtra": null,
    "zip": "43912",
    "city": "Bridgeport",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/bridgeport/906-national-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "We're more than a check cashing store! CheckSmart has you covered in one convenient location when you need to complete multiple financial services transactions at once. No more running from store to store to complete your errands. Our store in Bridgeport, OH on National Road offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. Stop by today to experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 40.07101233,
    "lng": -80.76127074,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 740-738-0015",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742652,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "z71G7YdCAS.jpeg",
        "locationId": 3365691,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365691/z71G7YdCAS.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365691/medium_z71G7YdCAS.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365691/thumb_z71G7YdCAS.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365691/eewrmRMcGG.jpeg"
      }
    ],
    "keywords": [
      "check cashing bridgeport",
      "checksmart bridgeport",
      "line of credit bridgeport"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Ohio",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:45.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 310,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23038",
    "id": 3365693,
    "dateCreated": "2022-05-31T13:25:49.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "East Broad Street",
    "streetNo": "4100",
    "streetAndNumber": "4100 East Broad Street",
    "addressExtra": null,
    "zip": "43213",
    "city": "Whitehall",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/whitehall/4100-east-broad-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to financial services, you need a great team to help! CheckSmart on East Broad St. in Whitehall, OH is the team you're looking for, so stop by today to get rolling. We offer an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Third party lending products available, contact store for details. We strive to make the process simple, so pop by the store and our team will walk you through each step and have you on your way quickly and efficiently!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 39.9746221,
    "lng": -82.8918621,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 614-863-2522",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742653,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "Ef5LpBhXny.jpeg",
        "locationId": 3365693,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365693/Ef5LpBhXny.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365693/medium_Ef5LpBhXny.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365693/thumb_Ef5LpBhXny.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365693/yJeHg1K5gK.jpeg"
      }
    ],
    "keywords": [
      "check cashing whitehall",
      "checksmart whitehall",
      "line of credit whitehall"
    ],
    "labels": [
      {
        "name": "Ohio",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:25:49.000+02:00",
    "averageRating": 4.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "17:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 47,
    "listingsBeingUpdated": 5,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 278,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Ohio",
        "id": 1381
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20547",
    "id": 3365707,
    "dateCreated": "2022-05-31T13:37:31.000+02:00",
    "lastUpdated": "2025-06-02T20:32:12.000+02:00",
    "name": "CheckSmart",
    "street": "Kelly Road",
    "streetNo": "19890",
    "streetAndNumber": "19890 Kelly Road",
    "addressExtra": null,
    "zip": "48225",
    "city": "Harper Woods",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/harper-woods/19890-kelly-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Looking for cash solutions and not sure which loan provider is right for you? Stop by the CheckSmart on Kelly Rd. in Harper Woods, MI to experience what makes us so unique! We're here to help, and once you're approved you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Creating customer experiences that are top notch and providing loan solutions to our customers is our goal each day, so stop by to get the process started!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:46.000+02:00",
    "country": "US",
    "lat": 42.4428918,
    "lng": -82.9463319,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 313-245-9560",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742668,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "wWhIwY9UFb.jpeg",
        "locationId": 3365707,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365707/wWhIwY9UFb.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365707/medium_wWhIwY9UFb.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365707/thumb_wWhIwY9UFb.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365707/BHNkyFvIFL.jpeg"
      }
    ],
    "keywords": [
      "check cashing harper woods",
      "checksmart harper woods",
      "payday loans harper woods"
    ],
    "labels": [
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:31.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 86,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21247",
    "id": 3365708,
    "dateCreated": "2022-05-31T13:37:32.000+02:00",
    "lastUpdated": "2025-06-02T20:32:12.000+02:00",
    "name": "CheckSmart",
    "street": "Eureka Road",
    "streetNo": "26150",
    "streetAndNumber": "26150 Eureka Road",
    "addressExtra": null,
    "zip": "48180",
    "city": "Taylor",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/taylor/26150-eureka-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is your go-to provider for loan solutions when you need cash in hand. Drop by the location at 19095 Eureka Rd. in Taylor, MI and our team will help you apply today! Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. If you need access to funds in a flash and you want to work with a team dedicated to finding solutions, stop by CheckSmart today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:46.000+02:00",
    "country": "US",
    "lat": 42.19728,
    "lng": -83.2918,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-946-0672",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742666,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "wNTXHOZOB0.jpeg",
        "locationId": 3365708,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365708/wNTXHOZOB0.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365708/medium_wNTXHOZOB0.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365708/thumb_wNTXHOZOB0.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365708/FlhbeBTxmX.jpeg"
      }
    ],
    "keywords": [
      "check cashing taylor",
      "checksmart taylor",
      "payday loans taylor"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:32.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 192,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21147",
    "id": 3365710,
    "dateCreated": "2022-05-31T13:37:33.000+02:00",
    "lastUpdated": "2025-06-03T23:31:58.000+02:00",
    "name": "CheckSmart",
    "street": "Telegraph Road",
    "streetNo": "7840",
    "streetAndNumber": "7840 Telegraph Road",
    "addressExtra": null,
    "zip": "48180",
    "city": "Taylor",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/taylor/7840-telegraph-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash shouldn't be so complicated, and at CheckSmart we work hard to make the process as convenient as possible. Our team at the Telegraph Rd. location in Taylor, MI can walk you through the process of application and help you find the solution that is best suited to your unique situation and needs. Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Let CheckSmart lend you a little help when you need it, stop by to learn more today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.2508296,
    "lng": -83.2713064,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 313-299-7784",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742662,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "ni6g26bDPA.jpeg",
        "locationId": 3365710,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365710/ni6g26bDPA.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365710/medium_ni6g26bDPA.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365710/thumb_ni6g26bDPA.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365710/CCmP9Upi6z.jpeg"
      }
    ],
    "keywords": [
      "check cashing taylor",
      "checksmart taylor",
      "payday loans taylor"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:33.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 847,
    "dataPoints": 149,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21547",
    "id": 3365709,
    "dateCreated": "2022-05-31T13:37:33.000+02:00",
    "lastUpdated": "2025-06-03T23:31:57.000+02:00",
    "name": "CheckSmart",
    "street": "East Michigan Avenue",
    "streetNo": "614",
    "streetAndNumber": "614 East Michigan Avenue",
    "addressExtra": null,
    "zip": "48197",
    "city": "Ypsilanti",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/ypsilanti/614-east-michigan-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Convenience matters when you're in need of a cash solution to one of life's many curveballs, and CheckSmart is here to help. Our team at the Michigan Ave. location in Ypsilanti, MI can walk you through the application process step-by-step, so pop by the store today to get started! Once approved you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. We make helping our customers the top focus of our day, so stop by and experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:46.000+02:00",
    "country": "US",
    "lat": 42.2410216,
    "lng": -83.60039205,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-485-6248",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742677,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "7CKUcOAlfB.jpeg",
        "locationId": 3365709,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365709/7CKUcOAlfB.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365709/medium_7CKUcOAlfB.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365709/thumb_7CKUcOAlfB.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365709/kkCfBEUvqx.jpeg"
      }
    ],
    "keywords": [
      "check cashing ypsilanti",
      "checksmart ypsilanti",
      "payday loans ypsilanti"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:32.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 42,
    "listingsBeingUpdated": 10,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 880,
    "dataPoints": 126,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21447",
    "id": 3365711,
    "dateCreated": "2022-05-31T13:37:34.000+02:00",
    "lastUpdated": "2025-06-04T07:13:41.000+02:00",
    "name": "CheckSmart",
    "street": "Plymouth Road",
    "streetNo": "33320",
    "streetAndNumber": "33320 Plymouth Road",
    "addressExtra": null,
    "zip": "48150",
    "city": "Livonia",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/livonia/33320-plymouth-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart offers cash solutions when you need them most. Our team at the Plymouth Rd. store in Livonia, MI can help you find the loan that will best fit your solution and then help you apply by walking through the process with you step-by-step, so visit the team today to get going. Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. When you need cash solutions, CheckSmart is just around the corner.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.36898,
    "lng": -83.37048,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-261-3857",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742654,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "v0Ppa5cGDe.jpeg",
        "locationId": 3365711,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365711/v0Ppa5cGDe.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365711/medium_v0Ppa5cGDe.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365711/thumb_v0Ppa5cGDe.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365711/Wfyt53s54X.jpeg"
      }
    ],
    "keywords": [
      "check cashing livonia",
      "checksmart livonia",
      "payday loans livonia"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:34.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 113,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20447",
    "id": 3365713,
    "dateCreated": "2022-05-31T13:37:35.000+02:00",
    "lastUpdated": "2025-05-31T14:32:23.000+02:00",
    "name": "CheckSmart",
    "street": "Orchard Lake Road",
    "streetNo": "980",
    "streetAndNumber": "980 Orchard Lake Road",
    "addressExtra": null,
    "zip": "48341",
    "city": "Pontiac",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/pontiac/980-orchard-lake-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, you need convenience you can count on. At CheckSmart on Orchard Lake Rd. in Pontiac, MI we'll have you in and out as quickly as possible so drop by! Once you're approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Let us help you out when you need it most to find the loan solution you need for your unique situation.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.62005652,
    "lng": -83.31996429,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 248-972-0810",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742676,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "snUkJHdgLv.jpeg",
        "locationId": 3365713,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365713/snUkJHdgLv.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365713/medium_snUkJHdgLv.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365713/thumb_snUkJHdgLv.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365713/6p6Hxdicna.jpeg"
      }
    ],
    "keywords": [
      "check cashing pontiac",
      "checksmart pontiac",
      "payday loans pontiac"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Michigan",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:35.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 75,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20047",
    "id": 3365714,
    "dateCreated": "2022-05-31T13:37:36.000+02:00",
    "lastUpdated": "2025-06-04T07:43:20.000+02:00",
    "name": "CheckSmart",
    "street": "Gratiot Avenue",
    "streetNo": "36656",
    "streetAndNumber": "36656 Gratiot Avenue",
    "addressExtra": null,
    "zip": "48035",
    "city": "Clinton Township",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/clinton-township/36656-gratiot-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Need access to cash but not sure where to turn? CheckSmart on Gratiot in Clinton Township, MI is here to help, so drop by to meet our exceptional team today. Once you've applied and received the green light, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Our team is standing by and ready to help you find the loan solution that best fits your situation, so drop in any time to chat and get the ball rolling.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.56673401,
    "lng": -82.89231464,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 586-792-4519",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742655,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "mjHBVmH1uj.jpeg",
        "locationId": 3365714,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365714/mjHBVmH1uj.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365714/medium_mjHBVmH1uj.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365714/thumb_mjHBVmH1uj.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365714/EwwmJbnpnK.jpeg"
      }
    ],
    "keywords": [
      "check cashing clinton township",
      "checksmart clinton township",
      "payday loans clinton township"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:36.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 149,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20147",
    "id": 3365716,
    "dateCreated": "2022-05-31T13:37:37.000+02:00",
    "lastUpdated": "2025-06-01T16:32:08.000+02:00",
    "name": "CheckSmart",
    "street": "Van Dyke Avenue",
    "streetNo": "27127",
    "streetAndNumber": "27127 Van Dyke Avenue",
    "addressExtra": null,
    "zip": "48093",
    "city": "Warren",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/warren/27127-van-dyke-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it is the goal for every customer who walks through the CheckSmart doors. Our team on Van Dyke in Warren, MI is dedicated to finding cash solutions for our clients, so stop by today to apply! Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here to help every step of the way, so don't hesitate to reach out with questions!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.49281433,
    "lng": -83.02821698,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 586-757-8995",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742683,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "thkeGkl2g7.jpeg",
        "locationId": 3365716,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365716/thkeGkl2g7.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365716/medium_thkeGkl2g7.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365716/thumb_thkeGkl2g7.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365716/JVfr1sDDsd.jpeg"
      }
    ],
    "keywords": [
      "check cashing warren",
      "checksmart warren",
      "payday loans warren"
    ],
    "labels": [
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:37.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 153,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21347",
    "id": 3365715,
    "dateCreated": "2022-05-31T13:37:37.000+02:00",
    "lastUpdated": "2025-06-03T23:31:58.000+02:00",
    "name": "CheckSmart",
    "street": "Six Mile Road",
    "streetNo": "29235",
    "streetAndNumber": "29235 Six Mile Road",
    "addressExtra": null,
    "zip": "48152",
    "city": "Livonia",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/livonia/29235-six-mile-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is your go-to provider for loan solutions when you need cash in hand. Drop by the location at 19095 Eureka Rd. in Taylor, MI and our team will help you apply today! Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. If you need access to funds in a flash and you want to work with a team dedicated to finding solutions, stop by CheckSmart today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.4121691,
    "lng": -83.3343086,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-261-2318",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742644,
        "dateCreated": "2025-04-17T16:23:25.000+02:00",
        "repoKey": "i6Ovjd769L.jpeg",
        "locationId": 3365715,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365715/i6Ovjd769L.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365715/medium_i6Ovjd769L.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365715/thumb_i6Ovjd769L.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365715/E78RWq6xhd.jpeg"
      }
    ],
    "keywords": [
      "check cashing livonia",
      "checksmart livonia",
      "payday loans livonia"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:36.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 864,
    "dataPoints": 98,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20347",
    "id": 3365717,
    "dateCreated": "2022-05-31T13:37:38.000+02:00",
    "lastUpdated": "2025-06-01T16:32:08.000+02:00",
    "name": "CheckSmart",
    "street": "Gratiot Avenue",
    "streetNo": "26151",
    "streetAndNumber": "26151 Gratiot Avenue",
    "addressExtra": null,
    "zip": "48066",
    "city": "Roseville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/roseville/26151-gratiot-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, CheckSmart is here to help. Stop by the Gratiot Ave. location in Roseville, MI to speak with a team member and find the loan solution that best fits your needs today. Once approved you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Customer service is our priority, so drop by and let us walk you through each step of the process!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.4890855,
    "lng": -82.9425514,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 586-771-3445",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742671,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "rP6mFbXCA6.jpeg",
        "locationId": 3365717,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365717/rP6mFbXCA6.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365717/medium_rP6mFbXCA6.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365717/thumb_rP6mFbXCA6.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365717/gbr1q583c1.jpeg"
      }
    ],
    "keywords": [
      "check cashing roseville",
      "checksmart roseville",
      "payday loans roseville"
    ],
    "labels": [
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Michigan",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:38.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 870,
    "dataPoints": 155,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20947",
    "id": 3365718,
    "dateCreated": "2022-05-31T13:37:39.000+02:00",
    "lastUpdated": "2025-06-02T20:32:12.000+02:00",
    "name": "CheckSmart",
    "street": "Michigan Ave",
    "streetNo": "46050",
    "streetAndNumber": "46050 Michigan Ave",
    "addressExtra": null,
    "zip": "48188",
    "city": "Canton",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/canton/46050-michigan-ave/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Cash solutions are just around the corner at CheckSmart, so stop by today to meet the team. Pop by the Michigan Ave. location in Canton Township, MI to fill out an application and you'll be on your way with cash in hand in no time at all! Once approved, you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Our team always makes customer service a priority, so drop by to experience the CheckSmart difference today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.27152,
    "lng": -83.49102,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-495-0523",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742667,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "8zS8wjUDyt.jpeg",
        "locationId": 3365718,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365718/8zS8wjUDyt.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365718/medium_8zS8wjUDyt.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365718/thumb_8zS8wjUDyt.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365718/WROj6zZCDn.jpeg"
      }
    ],
    "keywords": [
      "check cashing canton",
      "checksmart canton",
      "payday loans canton"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:38.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 866,
    "dataPoints": 147,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "21047",
    "id": 3365719,
    "dateCreated": "2022-05-31T13:37:39.000+02:00",
    "lastUpdated": "2025-06-01T16:32:08.000+02:00",
    "name": "CheckSmart",
    "street": "Eureka Road",
    "streetNo": "19095",
    "streetAndNumber": "19095 Eureka Road",
    "addressExtra": null,
    "zip": "48195",
    "city": "Southgate",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/mi/southgate/19095-eureka-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Choose CheckSmart when you are looking for cash solutions to life's little problems (or big problems, too!) We're always here to help, and the team at the store at 26150 Eureka Rd. in Southgate, MI will help you apply for a loan in a flash, so stop by today! Once approved you could access up to $600 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. The team is standing by and ready to help, so drop by today to learn more and get the process rolling.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 42.19827255,
    "lng": -83.22595789,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 734-281-1474",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742669,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "VQEXhPFZFy.jpeg",
        "locationId": 3365719,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365719/VQEXhPFZFy.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365719/medium_VQEXhPFZFy.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365719/thumb_VQEXhPFZFy.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365719/LVdyFMOwGQ.jpeg"
      }
    ],
    "keywords": [
      "check cashing southgate",
      "checksmart southgate",
      "payday loans southgate"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Michigan",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartMI",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:37:39.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 49,
    "listingsBeingUpdated": 3,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 132,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Michigan",
        "id": 1383
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "MI",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Detroit"
  },
  {
    "identifier": "20559",
    "id": 3365723,
    "dateCreated": "2022-05-31T13:41:51.000+02:00",
    "lastUpdated": "2025-06-03T23:31:58.000+02:00",
    "name": "CheckSmart",
    "street": "Outer Loop",
    "streetNo": "5627",
    "streetAndNumber": "5627 Outer Loop",
    "addressExtra": null,
    "zip": "40219",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/5627-outer-loop/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, look no further than CheckSmart. The Outer Loop location in Louisville, KY is conveniently located, so stop by today to start your application with a team member! Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We are dedicated to creating exceptional customer experiences and to helping our clients when they need us, so stop by today to experience the CheckSmart difference.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:45.000+02:00",
    "country": "US",
    "lat": 38.1396458,
    "lng": -85.6561508,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-961-8554",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742694,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "9sExLt1Nxr.jpeg",
        "locationId": 3365723,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365723/9sExLt1Nxr.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365723/medium_9sExLt1Nxr.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365723/thumb_9sExLt1Nxr.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365723/DYtt6zTpIK.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:51.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 29,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "20359",
    "id": 3365724,
    "dateCreated": "2022-05-31T13:41:52.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Terry Road",
    "streetNo": "5921",
    "streetAndNumber": "5921 Terry Road",
    "addressExtra": null,
    "zip": "40216",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/5921-terry-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash doesn't have to be complicated, and CheckSmart is dedicated to providing cash solutions to our customers as quickly and efficiently as possible. Drop by the Terry Rd. location in Louisville, KY to apply and to chat with one of our team members about the loans options available for your situation. Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. CheckSmart is dedicated to providing the best experience possible for our customers, so stop by today to get started!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.16612414,
    "lng": -85.86675315,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-447-4744",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742665,
        "dateCreated": "2025-04-17T16:23:28.000+02:00",
        "repoKey": "JrOjvjobjr.jpeg",
        "locationId": 3365724,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365724/JrOjvjobjr.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365724/medium_JrOjvjobjr.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365724/thumb_JrOjvjobjr.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365724/0MdOAuNMqr.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:52.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 49,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "20659",
    "id": 3365725,
    "dateCreated": "2022-05-31T13:41:52.000+02:00",
    "lastUpdated": "2025-06-02T20:32:12.000+02:00",
    "name": "CheckSmart",
    "street": "Dixie Highway",
    "streetNo": "3421",
    "streetAndNumber": "3421 Dixie Highway",
    "addressExtra": null,
    "zip": "41018",
    "city": "Erlanger",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/erlanger/3421-dixie-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart is here to help when you need access to cash solutions that fit your specific needs and situation. The Check Smart store on Dixie Highway in Erlanger, KY is conveniently located, and the team is dedicated to exceptional customer service so stop by today! Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Help is on the way, just pop by CheckSmart to get started today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 39.01672174,
    "lng": -84.59959863,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-727-4569",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742687,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "anCbQ2imEa.jpeg",
        "locationId": 3365725,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365725/anCbQ2imEa.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365725/medium_anCbQ2imEa.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365725/thumb_anCbQ2imEa.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365725/0sXBYzVxGY.jpeg"
      }
    ],
    "keywords": [
      "check cashing erlanger",
      "checksmart erlanger",
      "payday loans erlanger"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:52.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 74,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20159",
    "id": 3365727,
    "dateCreated": "2022-05-31T13:41:53.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Dixie Highway",
    "streetNo": "10023",
    "streetAndNumber": "10023 Dixie Highway",
    "addressExtra": null,
    "zip": "40272",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/10023-dixie-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Convenience is key when you need access to cash, and CheckSmart makes it a priority to serve our clients at the highest level possible. Stop by the store at 10023 Dixie Highway in Louisville, KY to chat with a team member about our services and apply for a loan! Once approved you could be on your way with cash in hand; we can offer up to $500 through a Payroll Advance Loan to qualified applicants. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We are here to help and customer service is our top priority, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.1092723,
    "lng": -85.8650016,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-935-9905",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742684,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "JhoJ3fr99J.jpeg",
        "locationId": 3365727,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365727/JhoJ3fr99J.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365727/medium_JhoJ3fr99J.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365727/thumb_JhoJ3fr99J.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365727/oWlmG8JzCb.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:53.000+02:00",
    "averageRating": 3.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 32,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "20259",
    "id": 3365726,
    "dateCreated": "2022-05-31T13:41:53.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Preston Highway",
    "streetNo": "8230",
    "streetAndNumber": "8230 Preston Highway",
    "addressExtra": null,
    "zip": "40219",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/5005-preston-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash, you can count on CheckSmart to offer cash solutions that fit your needs. Stop by the 8230 Preston Highway location in Louisville, KY today to apply and you can be on your way with cash in hand in no time at all! If approved you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. We are committed to providing exceptional service to our customers, so drop by and connect with our team to experience the CheckSmart difference!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.13218321,
    "lng": -85.68395087,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-969-0026",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742686,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "TKTGNdq9dF.jpeg",
        "locationId": 3365726,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365726/TKTGNdq9dF.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365726/medium_TKTGNdq9dF.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365726/thumb_TKTGNdq9dF.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365726/c419LL4UCR.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:53.000+02:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 840,
    "dataPoints": 42,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "21559",
    "id": 3365728,
    "dateCreated": "2022-05-31T13:41:54.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Preston Highway",
    "streetNo": "5005",
    "streetAndNumber": "5005 Preston Highway",
    "addressExtra": null,
    "zip": "40213",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/5005-preston-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart offers cash solutions that work for our customers and their unique situations. Our team at the 5005 Preston Highway store in Louisville, KY will help you apply, so stop by today! Once you're approved, you could qualify for up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Let our team help you with the access to cash you need, stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.17527,
    "lng": -85.71291,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-810-0861",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742699,
        "dateCreated": "2025-04-17T16:23:31.000+02:00",
        "repoKey": "2WFUbaNaAU.jpeg",
        "locationId": 3365728,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365728/2WFUbaNaAU.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365728/medium_2WFUbaNaAU.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365728/thumb_2WFUbaNaAU.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365728/vjrfEvCdbu.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:54.000+02:00",
    "averageRating": 3.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 29,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "21159",
    "id": 3365729,
    "dateCreated": "2022-05-31T13:41:55.000+02:00",
    "lastUpdated": "2025-06-02T20:32:13.000+02:00",
    "name": "CheckSmart",
    "street": "Highland Pike",
    "streetNo": "1990",
    "streetAndNumber": "1990 Highland Pike",
    "addressExtra": null,
    "zip": "41011",
    "city": "Fort Wright",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/fort-wright/1990-highland-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "If you need cash in hand as soon as possible and you're not sure where to turn, drop by your neighborhood CheckSmart. Our team of experts at the Highland Pike location in Fort Wright, KY can help you apply and get you on your way with cash in hand quickly, so drop by today! Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Let your friends at CheckSmart offer you a hand, stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 39.03679347,
    "lng": -84.5326732,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-426-5196",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742693,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "CWk1OqQpKF.jpeg",
        "locationId": 3365729,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365729/CWk1OqQpKF.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365729/medium_CWk1OqQpKF.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365729/thumb_CWk1OqQpKF.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365729/qnQAX2q4W0.jpeg"
      }
    ],
    "keywords": [
      "check cashing fort wright",
      "checksmart fort wright",
      "payday loans fort wright"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:55.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 867,
    "dataPoints": 37,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20959",
    "id": 3365730,
    "dateCreated": "2022-05-31T13:41:56.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Madison Avenue",
    "streetNo": "1713",
    "streetAndNumber": "1713 Madison Avenue",
    "addressExtra": null,
    "zip": "41011",
    "city": "Covington",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/covington/1713-madison-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it in a timely fashion and in a convenient location is the goal of every CheckSmart location. The team at the store on Madison Ave. in Covington, KY can help you find cash solutions that work for your situation quickly and efficiently, so drop by today to get started. To our qualified customers we can offer up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. If you need access to cash, stop by CheckSmart and connect with our team today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 39.0702427,
    "lng": -84.5073754,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-291-2666",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742681,
        "dateCreated": "2025-04-17T16:23:29.000+02:00",
        "repoKey": "nYLqB9KVgQ.jpeg",
        "locationId": 3365730,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365730/nYLqB9KVgQ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365730/medium_nYLqB9KVgQ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365730/thumb_nYLqB9KVgQ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365730/Q3q4wWoKYh.jpeg"
      }
    ],
    "keywords": [
      "check cashing covington",
      "checksmart covington",
      "payday loans covington"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:56.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 77,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21659",
    "id": 3365731,
    "dateCreated": "2022-05-31T13:41:56.000+02:00",
    "lastUpdated": "2025-06-01T16:32:08.000+02:00",
    "name": "CheckSmart",
    "street": "Bardstown Road",
    "streetNo": "3319",
    "streetAndNumber": "3319 Bardstown Road",
    "addressExtra": null,
    "zip": "40218",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/3319-bardstown-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash and a team that is great to work with, stop by CheckSmart. The team at the store on Bardstown Rd in Louisville, KY can help, so drop by today to get the application rolling. Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers an array of financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. CheckSmart is your one stop solution, so stop by today and meet the team!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.20717115,
    "lng": -85.66727577,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-812-1234",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742696,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "cf5VZp4Skm.jpeg",
        "locationId": 3365731,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365731/cf5VZp4Skm.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365731/medium_cf5VZp4Skm.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365731/thumb_cf5VZp4Skm.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365731/cXfj4VfzFw.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:56.000+02:00",
    "averageRating": 3.9,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 40,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "20459",
    "id": 3365733,
    "dateCreated": "2022-05-31T13:41:57.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Taylor Boulevard",
    "streetNo": "3426",
    "streetAndNumber": "3426 Taylor Boulevard",
    "addressExtra": null,
    "zip": "40215",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/3426-taylor-boulevard/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "At CheckSmart we're dedicated to providing cash solutions to our clients when they walk through our doors. The team at the Taylor Blvd. location in Louisville, KY look forward to walking you through the application process, so stop by today! Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Our team will help you find the loan that is right for you, so stop by today to get the process rolling.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.19832,
    "lng": -85.78372,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-361-9200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742703,
        "dateCreated": "2025-04-17T16:23:33.000+02:00",
        "repoKey": "tf2Ys0Qcev.jpeg",
        "locationId": 3365733,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365733/tf2Ys0Qcev.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365733/medium_tf2Ys0Qcev.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365733/thumb_tf2Ys0Qcev.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365733/1gkwAKQRDY.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Kentucky",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:57.000+02:00",
    "averageRating": 3.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 44,
    "listingsBeingUpdated": 8,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 851,
    "dataPoints": 45,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "21259",
    "id": 3365732,
    "dateCreated": "2022-05-31T13:41:57.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "Alexandria Pike",
    "streetNo": "3800",
    "streetAndNumber": "3800 Alexandria Pike",
    "addressExtra": null,
    "zip": "41076",
    "city": "Cold Spring",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/cold-spring/3800-alexandria-pike/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Looking for access to needed funds and not sure where to turn? The CheckSmart store team on Alexandria Pike in Cold Spring, KY is standing by and ready to help, so pop by today to apply for a loan that will offer the cash solutions you're looking for. To our qualified applicants we offer up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Loan solutions are just around the corner at CheckSmart, and we look forward to helping you!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 39.0254043,
    "lng": -84.4468811,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-912-7350",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742697,
        "dateCreated": "2025-04-17T16:23:30.000+02:00",
        "repoKey": "3uece8fenC.jpeg",
        "locationId": 3365732,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365732/3uece8fenC.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365732/medium_3uece8fenC.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365732/thumb_3uece8fenC.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365732/VNBKSkZLst.jpeg"
      }
    ],
    "keywords": [
      "check cashing cold spring",
      "checksmart cold spring",
      "payday loans cold spring"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:57.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 874,
    "dataPoints": 27,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "20059",
    "id": 3365734,
    "dateCreated": "2022-05-31T13:41:58.000+02:00",
    "lastUpdated": "2025-06-02T20:32:13.000+02:00",
    "name": "CheckSmart",
    "street": "Dixie Highway",
    "streetNo": "4628",
    "streetAndNumber": "4628 Dixie Highway",
    "addressExtra": null,
    "zip": "40216",
    "city": "Louisville",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/louisville/4628-dixie-highway/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash and you're not sure what options you have, CheckSmart may have the solution. Stop by the store at 4628 Dixie Highway in Louisville, KY today to speak with a team member about the cash solutions our store offers and to apply. Once approved, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and eveb Gift Card Buyback. We are focused on offering outstanding customer service to everyone who walks through our doors, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:44.000+02:00",
    "country": "US",
    "lat": 38.17703,
    "lng": -85.82066,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 502-447-5200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742705,
        "dateCreated": "2025-04-17T16:23:43.000+02:00",
        "repoKey": "nGarfkudkd.jpeg",
        "locationId": 3365734,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365734/nGarfkudkd.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365734/medium_nGarfkudkd.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365734/thumb_nGarfkudkd.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365734/XZVnctTl3I.jpeg"
      }
    ],
    "keywords": [
      "check cashing louisville",
      "checksmart louisville",
      "payday loans louisville"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:58.000+02:00",
    "averageRating": 4.1,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 53,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "identifier": "20759",
    "id": 3365735,
    "dateCreated": "2022-05-31T13:41:59.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "US-42",
    "streetNo": "8459-D",
    "streetAndNumber": "8459-D US-42",
    "addressExtra": null,
    "zip": "41042",
    "city": "Florence",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/florence/8459-d-us-42/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Cash solutions to life's unexpected rainy days are just around the corner at CheckSmart. Stop by the US 42 location in Florence, KY to chat with a team member and apply for a loan. Once qualified, you could access up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. Let us help get you back to brighter patches through our on-the-spot loan solutions at CheckSmart.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:43.000+02:00",
    "country": "US",
    "lat": 38.97749,
    "lng": -84.65576,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-647-7500",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742588,
        "dateCreated": "2025-04-17T16:23:11.000+02:00",
        "repoKey": "zAS8TNnuBU.jpeg",
        "locationId": 3365735,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365735/zAS8TNnuBU.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365735/medium_zAS8TNnuBU.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365735/thumb_zAS8TNnuBU.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365735/4ifOopWCRx.jpeg"
      }
    ],
    "keywords": [
      "check cashing florence",
      "checksmart florence",
      "payday loans florence"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:41:59.000+02:00",
    "averageRating": 4.2,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "dayOfWeek": 7,
        "from1": "11:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 855,
    "dataPoints": 78,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21059",
    "id": 3365736,
    "dateCreated": "2022-05-31T13:42:01.000+02:00",
    "lastUpdated": "2025-06-02T20:32:13.000+02:00",
    "name": "CheckSmart",
    "street": "Broadway Street",
    "streetNo": "59",
    "streetAndNumber": "59 Broadway Street",
    "addressExtra": null,
    "zip": "41035",
    "city": "Dry Ridge",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/ky/dry-ridge/59-broadway-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need funds to see you through, CheckSmart has you covered. Drop by the Broadway St. location in Dry Ridge, KY to apply with one of our expert team members. After reviewing your options and getting the approval green light, you could qualify for up to $500 through a Payroll Advance Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Life throws curveballs, sometimes, but CheckSmart is here to help when you need us!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T15:55:43.000+02:00",
    "country": "US",
    "lat": 38.68136747,
    "lng": -84.59621212,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-823-2222",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742590,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "pvu5u2vtfs.jpeg",
        "locationId": 3365736,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365736/pvu5u2vtfs.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365736/medium_pvu5u2vtfs.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365736/thumb_pvu5u2vtfs.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365736/Ev1G6id6Xr.jpeg"
      }
    ],
    "keywords": [
      "check cashing dry ridge",
      "checksmart dry ridge",
      "payday loans dry ridge"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:42:00.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 51,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Kentucky",
        "id": 1384
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "23229",
    "id": 3365742,
    "dateCreated": "2022-05-31T13:47:37.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "West Indian School Road",
    "streetNo": "4301",
    "streetAndNumber": "4301 West Indian School Road",
    "addressExtra": null,
    "zip": "85031",
    "city": "Phoenix",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/phoenix/4301-west-indian-school-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need cash in hand to cover an unexpected expense or to see you through one of life's emergencies, CheckSmart has you covered. Visit our store at 4301 W. Indian School Rd. Phoenix, AZ to learn more about our loan options. If approved, you could receive up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here to help when you need us, so don't hesitate to reach out with any questions.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 33.49460628,
    "lng": -112.15201362,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 602-272-8688",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742589,
        "dateCreated": "2025-04-17T16:23:11.000+02:00",
        "repoKey": "4gs7pkX1OD.jpeg",
        "locationId": 3365742,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365742/4gs7pkX1OD.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365742/medium_4gs7pkX1OD.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365742/thumb_4gs7pkX1OD.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365742/Qpsjyfnagp.jpeg"
      }
    ],
    "keywords": [
      "check cashing phoenix",
      "checksmart phoenix",
      "installment loans phoenix",
      "payday loans phoenix",
      "title loans phoenix"
    ],
    "labels": [
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:37.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 861,
    "dataPoints": 35,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "23029",
    "id": 3365743,
    "dateCreated": "2022-05-31T13:47:38.000+02:00",
    "lastUpdated": "2025-06-04T16:22:45.000+02:00",
    "name": "CheckSmart",
    "street": "West Indian School Road",
    "streetNo": "1930",
    "streetAndNumber": "1930 West Indian School Road",
    "addressExtra": null,
    "zip": "85015",
    "city": "Phoenix",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/phoenix/1930-west-indian-school-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "If you need to access cash but feel like you've run out of options, we have good news! CheckSmart is here to help you and the team at the Phoenix, AZ store at 1930 W Indian School Rd has answers to your personal loan questions. Stop by today to learn how you could qualify for up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're here to help, so stop by today!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 33.4955751,
    "lng": -112.1010584,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 602-297-9777",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742595,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "qtudt9d5zl.jpeg",
        "locationId": 3365743,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365743/qtudt9d5zl.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365743/medium_qtudt9d5zl.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365743/thumb_qtudt9d5zl.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365743/HGvLW8ERD1.jpeg"
      }
    ],
    "keywords": [
      "check cashing phoenix",
      "checksmart phoenix",
      "installment loans phoenix",
      "payday loans phoenix",
      "title loans phoenix"
    ],
    "labels": [
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:38.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 860,
    "dataPoints": 320,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "22329",
    "id": 3365744,
    "dateCreated": "2022-05-31T13:47:39.000+02:00",
    "lastUpdated": "2025-06-03T23:32:00.000+02:00",
    "name": "CheckSmart",
    "street": "East 22nd Street",
    "streetNo": "5504",
    "streetAndNumber": "5504 East 22nd Street",
    "addressExtra": null,
    "zip": "85711",
    "city": "Tucson",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/tucson/5504-east-22nd-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Life throws us for a loop sometimes and extra cash is needed to weather the storm. When you need cash solutions, CheckSmart is here for you so stop by the store in Tucson, AZ on 22nd St. to get the process started! If approved for a loan, you can receive up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan! We're more than your go-to loan company! Our store offers financial services includingCheck Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We're always here to help, so let our team assist you as you choose the loan that best fits your needs.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 32.2065024,
    "lng": -110.87476008,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 520-790-2600",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742593,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "FiS5fRriD4.jpeg",
        "locationId": 3365744,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365744/FiS5fRriD4.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365744/medium_FiS5fRriD4.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365744/thumb_FiS5fRriD4.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365744/D4LAZBiv6z.jpeg"
      }
    ],
    "keywords": [
      "check cashing tucson",
      "checksmart tucson",
      "installment loans tucson",
      "payday loans tucson",
      "title loans tucson"
    ],
    "labels": [
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:39.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 48,
    "listingsBeingUpdated": 4,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 869,
    "dataPoints": 278,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "23429",
    "id": 3365745,
    "dateCreated": "2022-05-31T13:47:39.000+02:00",
    "lastUpdated": "2025-06-03T23:32:00.000+02:00",
    "name": "CheckSmart",
    "street": "West Cactus Road",
    "streetNo": "6690",
    "streetAndNumber": "6690 West Cactus Road",
    "addressExtra": "#103",
    "zip": "85304",
    "city": "Glendale",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/glendale/6690-west-cactus-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when life has thrown a hurdle in your path shouldn't be complicated. That's why the team at the CheckSmart store on Cactus Rd. in Glendale, AZ work hard to make the process simple. Once approved, you could access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers an array financial services including: Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Stop by today to learn more about the cash solutions we have available.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 33.59659059,
    "lng": -112.20229384,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 623-334-0007",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742592,
        "dateCreated": "2025-04-17T16:23:12.000+02:00",
        "repoKey": "kNGKrnoN40.jpeg",
        "locationId": 3365745,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365745/kNGKrnoN40.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365745/medium_kNGKrnoN40.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365745/thumb_kNGKrnoN40.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365745/rzOIA78M7r.jpeg"
      }
    ],
    "keywords": [
      "check cashing glendale",
      "checksmart glendale",
      "installment loans glendale",
      "payday loans glendale",
      "title loans glendale"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:39.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 883,
    "dataPoints": 118,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "22029",
    "id": 3365746,
    "dateCreated": "2022-05-31T13:47:40.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "West Ajo Way",
    "streetNo": "727",
    "streetAndNumber": "727 West Ajo Way",
    "addressExtra": null,
    "zip": "85714",
    "city": "Tucson",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/tucson/727-west-ajo-way/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it with a focus on your convenience is our goal at CheckSmart. Stop by the Ajo Way location in Tucson, AZ to learn more about our loans and find the right fit for your situation. You could be approved for up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We look forward to meeting you and helping find the solution that is a best fit for you!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:58.000+02:00",
    "country": "US",
    "lat": 32.1774043,
    "lng": -110.9807944,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 520-746-3200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742596,
        "dateCreated": "2025-04-17T16:23:14.000+02:00",
        "repoKey": "z6pzp5pyqK.jpeg",
        "locationId": 3365746,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365746/z6pzp5pyqK.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365746/medium_z6pzp5pyqK.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365746/thumb_z6pzp5pyqK.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365746/sz5uTO9rAg.jpeg"
      }
    ],
    "keywords": [
      "check cashing tucson",
      "checksmart tucson",
      "installment loans tucson",
      "payday loans tucson",
      "title loans tucson"
    ],
    "labels": [
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:40.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 106,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "21529",
    "id": 3365747,
    "dateCreated": "2022-05-31T13:47:41.000+02:00",
    "lastUpdated": "2025-06-03T23:31:59.000+02:00",
    "name": "CheckSmart",
    "street": "South 51st Avenue",
    "streetNo": "6170",
    "streetAndNumber": "6170 South 51st Avenue",
    "addressExtra": null,
    "zip": "85339",
    "city": "Laveen Village",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/laveen-village/6170-south-51st-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need access to cash rather quickly, CheckSmart is your one stop solution. The team at the 51st Ave. location in Laveen Village, AZ can walk you through the application process when you stop by the store. Once approved, you can access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. The team at Check Smart is always standing by and ready to help when you need it most, so stop by today to get the process started!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:57.000+02:00",
    "country": "US",
    "lat": 33.39049,
    "lng": -112.16913,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 602-237-8700",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742627,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "8j5k3E6Ylu.jpeg",
        "locationId": 3365747,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365747/8j5k3E6Ylu.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365747/medium_8j5k3E6Ylu.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365747/thumb_8j5k3E6Ylu.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365747/mIXwDk0hLM.jpeg"
      }
    ],
    "keywords": [
      "check cashing laveen village",
      "checksmart laveen village",
      "installment loans laveen village",
      "payday loans laveen village",
      "title loans laveen village"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:41.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 50,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 43,
    "listingsBeingUpdated": 9,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 833,
    "dataPoints": 105,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "21329",
    "id": 3365750,
    "dateCreated": "2022-05-31T13:47:43.000+02:00",
    "lastUpdated": "2025-06-01T16:32:09.000+02:00",
    "name": "CheckSmart",
    "street": "East Southern Avenue",
    "streetNo": "131",
    "streetAndNumber": "131 East Southern Avenue",
    "addressExtra": null,
    "zip": "85282",
    "city": "Tempe",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/tempe/131-east-southern-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash when you need it doesn't have to be complicated. Visit the Tempe, AZ CheckSmart location on Southern Ave and let our team guide you through steps towards accessing a loan. If you're approved, you can access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. When you need a little help, we're here for you.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:57.000+02:00",
    "country": "US",
    "lat": 33.3924617,
    "lng": -111.9371196,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 480-966-1771",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742605,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "AyUM9wzPlY.jpeg",
        "locationId": 3365750,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365750/AyUM9wzPlY.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365750/medium_AyUM9wzPlY.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365750/thumb_AyUM9wzPlY.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365750/hGG1Bx5wUA.jpeg"
      }
    ],
    "keywords": [
      "check cashing tempe",
      "checksmart tempe",
      "installment loans tempe",
      "payday loans tempe",
      "title loans tempe"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:43.000+02:00",
    "averageRating": 4.3,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 863,
    "dataPoints": 186,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "23329",
    "id": 3365749,
    "dateCreated": "2022-05-31T13:47:43.000+02:00",
    "lastUpdated": "2025-06-03T23:32:00.000+02:00",
    "name": "CheckSmart",
    "street": "West Thomas Road",
    "streetNo": "8310",
    "streetAndNumber": "8310 West Thomas Road",
    "addressExtra": null,
    "zip": "85037",
    "city": "Phoenix",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/phoenix/8310-west-thomas-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "We know that access to cash when you need it is extremely important. At the CheckSmart store on Thomas Rd. in Phoenix, AZ, helping our customers is what drives us each and every day! If you are approved, we can offer up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers various financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Stop by today to learn more and apply; we look forward to meeting you!",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:57.000+02:00",
    "country": "US",
    "lat": 33.480377,
    "lng": -112.2384566,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 623-245-1200",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742598,
        "dateCreated": "2025-04-17T16:23:14.000+02:00",
        "repoKey": "xiU6JeMIxc.jpeg",
        "locationId": 3365749,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365749/xiU6JeMIxc.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365749/medium_xiU6JeMIxc.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365749/thumb_xiU6JeMIxc.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365749/bDswj53LjG.jpeg"
      }
    ],
    "keywords": [
      "check cashing phoenix",
      "checksmart phoenix",
      "installment loans phoenix",
      "payday loans phoenix",
      "title loans phoenix"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "Arizona",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:43.000+02:00",
    "averageRating": 4.8,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 868,
    "dataPoints": 283,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "22429",
    "id": 3365754,
    "dateCreated": "2022-05-31T13:47:46.000+02:00",
    "lastUpdated": "2025-06-04T06:23:57.000+02:00",
    "name": "CheckSmart",
    "street": "South 6th Avenue",
    "streetNo": "3802",
    "streetAndNumber": "3802 South 6th Avenue",
    "addressExtra": null,
    "zip": "85714",
    "city": "Tucson",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/tucson/3802-south-6th-avenue/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Access to cash shouldn't be complicated, so CheckSmart has cash solutions that make sense. Stop by our 6th Ave location in Tucson, AZ to start the application process; our team will be standing by to answer any questions you have and to make the process simple. If approved for a loan, you could accessup to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and even Gift Card Buyback. The team at CheckSmart has a goal to make the process as simple as possible, so stop by today to get the ball rolling.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:57.000+02:00",
    "country": "US",
    "lat": 32.1775345,
    "lng": -110.96863478,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 520-295-1788",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742597,
        "dateCreated": "2025-04-17T16:23:14.000+02:00",
        "repoKey": "ImkZ4r3eIZ.jpeg",
        "locationId": 3365754,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3365754/ImkZ4r3eIZ.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365754/medium_ImkZ4r3eIZ.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365754/thumb_ImkZ4r3eIZ.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3365754/d6zavhhug7.jpeg"
      }
    ],
    "keywords": [
      "check cashing tucson",
      "checksmart tucson",
      "installment loans tucson",
      "payday loans tucson",
      "title loans tucson"
    ],
    "labels": [
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-05-31T13:47:46.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 859,
    "dataPoints": 86,
    "linkedToLocationGroups": [
      {
        "name": "CheckSmart_Arizona",
        "id": 1385
      },
      {
        "name": "CheckSmart Locations",
        "id": 1387
      },
      {
        "name": "CheckSmart",
        "id": 1391
      }
    ],
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "20830",
    "id": 3501426,
    "dateCreated": "2022-09-02T06:55:08.000+02:00",
    "lastUpdated": "2025-06-04T23:11:25.000+02:00",
    "name": "CheckSmart",
    "street": "Coliseum Boulevard West",
    "streetNo": "1010",
    "streetAndNumber": "1010 Coliseum Boulevard West",
    "addressExtra": null,
    "zip": "46808",
    "city": "Fort Wayne",
    "cellphone": null,
    "fax": "+1 260-496-8975",
    "website": "https://www.checksmart.com/store/IN/Fort%20Wayne/1010-east-coliseum-blvd/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": null,
    "descriptionLong": null,
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-06-04T23:10:44.000+02:00",
    "country": "US",
    "lat": 41.118298,
    "lng": -85.15654,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 260-496-8875",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 141281758,
        "dateCreated": "2025-06-04T21:58:06.000+02:00",
        "repoKey": "rpzL5pcsED.png",
        "locationId": 3501426,
        "description": null,
        "identifier": null,
        "main": true,
        "logo": false,
        "type": "MAIN",
        "url": "/uploads/userpics/3501426/rpzL5pcsED.png",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3501426/medium_rpzL5pcsED.png",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3501426/thumb_rpzL5pcsED.png",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://res.cloudinary.com/tmxfoc/image/upload/store-fronts/check-smart.png"
      }
    ],
    "keywords": [
      "cash advance",
      "cash advance near me",
      "cashing near me",
      "Flex loans near me",
      "Installment loan near me",
      "line of credit near me",
      "Money order near me",
      "money transfer near me",
      "payday loans",
      "payday loans near me",
      "same day loans",
      "Sell gift cards",
      "title loan near me"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465
    ],
    "locationSyncable": false,
    "businessId": 1298283,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-09-02T06:55:08.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 88,
    "missingMandatoryFields": [
      "DESCRIPTION_SHORT"
    ],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 33,
    "listingsBeingUpdated": 19,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 806,
    "dataPoints": 12,
    "province": "IN",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "identifier": "21229",
    "id": 3501425,
    "dateCreated": "2022-09-02T06:55:08.000+02:00",
    "lastUpdated": "2025-06-01T17:00:24.000+02:00",
    "name": "CheckSmart",
    "street": "East Main Street",
    "streetNo": "6771",
    "streetAndNumber": "6771 East Main Street",
    "addressExtra": null,
    "zip": "85205",
    "city": "Mesa",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/mesa/6771-east-main-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "When you need cash, convenience and a team you can trust are key. Visit the CheckSmart team in Mesa, AZ at our store on Main St. to learn more about how you could qualify for up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. Our team is standing by and looking forward to helping you. CheckSmart is here to help when you need it most.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:57.000+02:00",
    "country": "US",
    "lat": 33.41524953,
    "lng": -111.6848501,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 480-981-6999",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742604,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "cNc0zy0yOI.jpeg",
        "locationId": 3501425,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3501425/cNc0zy0yOI.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3501425/medium_cNc0zy0yOI.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3501425/thumb_cNc0zy0yOI.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3501425/VW9Xo65o9I.jpeg"
      }
    ],
    "keywords": [
      "check cashing mesa",
      "checksmart mesa",
      "installment loans mesa",
      "payday loans mesa",
      "title loans mesa"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-09-02T06:55:08.000+02:00",
    "averageRating": 4.4,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 52,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 46,
    "listingsBeingUpdated": 6,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 845,
    "dataPoints": 152,
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "23829",
    "id": 3783215,
    "dateCreated": "2023-03-31T19:28:03.000+02:00",
    "lastUpdated": "2025-06-01T18:11:45.000+02:00",
    "name": "CheckSmart",
    "street": "West Bell Road",
    "streetNo": "3510",
    "streetAndNumber": "3510 West Bell Road",
    "addressExtra": null,
    "zip": "85308",
    "city": "Glendale",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/az/glendale/3510-west-bell-road/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "Short on cash and need help quickly without a hassle? CheckSmart on Bell Rd. in Glendale, AZ is here to help  and can have you in and out of the store in a flash, cash in hand. If approved, you can access up to $5,000 through an Installment Loan, up to $800 through an Express Single Payment Loan, or even up to $25,000 through a Title Loan. We're more than your go-to loan company! Our store offers financial services including Check Cashing, Green Dot™ Visa® Debit Cards, Western Union Money Transfers, Money Orders, Bill Pay, and Gift Card Buyback. We want to be your go-to store when you are looking for cash solutions to life's inconveniences, so stop by today to connect with our team.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-21T17:26:56.000+02:00",
    "country": "US",
    "lat": 33.6407378,
    "lng": -112.1348594,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 602-896-9700",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742616,
        "dateCreated": "2025-04-17T16:23:24.000+02:00",
        "repoKey": "9sYwFaBDHh.jpeg",
        "locationId": 3783215,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/3783215/9sYwFaBDHh.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3783215/medium_9sYwFaBDHh.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3783215/thumb_9sYwFaBDHh.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/3783215/EEOCEfOSrs.jpeg"
      }
    ],
    "keywords": [
      "check cashing glendale",
      "checksmart glendale",
      "installment loans glendale",
      "payday loans glendale",
      "title loans glendale"
    ],
    "labels": [
      {
        "name": "CheckSmart",
        "adminOnly": false
      },
      {
        "name": "Arizona",
        "adminOnly": false
      },
      {
        "name": "CheckSmartAZ",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2023-04-30T19:28:03.000+02:00",
    "averageRating": 4.5,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "18:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "10:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "url_facebook",
        "displayName": "Facebook",
        "valueType": "URL",
        "valueMetadata": null,
        "groupDisplayName": "Place page URLs",
        "value": "https://www.facebook.com/CheckSmartFinancial"
      },
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 42,
    "listingsBeingUpdated": 10,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 848,
    "dataPoints": 141,
    "province": "AZ",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/Phoenix"
  },
  {
    "identifier": "20859",
    "id": 4389551,
    "dateCreated": "2024-03-27T21:05:29.000+01:00",
    "lastUpdated": "2025-06-04T04:53:50.000+02:00",
    "name": "CheckSmart",
    "street": "Monmouth Street",
    "streetNo": "1851",
    "streetAndNumber": "1851 Monmouth Street",
    "addressExtra": null,
    "zip": "41071",
    "city": "Newport",
    "cellphone": null,
    "fax": "+1 859-581-2561",
    "website": "https://www.checksmart.com/store/KY/Newport/1851-monmouth-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": null,
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-17T16:26:04.000+02:00",
    "country": "US",
    "lat": 39.07984014,
    "lng": -84.48026222,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 859-581-8400",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742649,
        "dateCreated": "2025-04-17T16:23:27.000+02:00",
        "repoKey": "TrTgKmQbl4.jpeg",
        "locationId": 4389551,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/4389551/TrTgKmQbl4.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389551/medium_TrTgKmQbl4.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389551/thumb_TrTgKmQbl4.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389551/YhCpHr6GNg.jpeg"
      }
    ],
    "keywords": [
      "check cashing newport",
      "payday loans newport"
    ],
    "labels": [
      {
        "name": "Kentucky",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": true
      }
    ],
    "categories": [
      2693,
      465,
      1688,
      1145,
      1163
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2024-04-27T21:05:29.000+02:00",
    "averageRating": 4.6,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 751,
    "dataPoints": 48,
    "province": "KY",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  },
  {
    "identifier": "21038",
    "id": 4389559,
    "dateCreated": "2024-03-27T21:25:32.000+01:00",
    "lastUpdated": "2025-06-04T04:53:49.000+02:00",
    "name": "CheckSmart",
    "street": "Main Street",
    "streetNo": "658",
    "streetAndNumber": "658 Main Street",
    "addressExtra": null,
    "zip": "45202",
    "city": "Cincinnati",
    "cellphone": null,
    "fax": null,
    "website": "https://www.checksmart.com/store/oh/cincinnati/658-main-street/",
    "email": "customerservice@mychecksmart.com",
    "descriptionShort": "When you need cash, CheckSmart is here to work with you to find a solution that best fits your needs. We offer financial solutions from Payday Loans, Check Cashing, Money Transfers, and more!",
    "descriptionLong": "CheckSmart offers a variety of products and services customized to fit your everyday financial needs. We can assist with loan services, check cashing, money transfers, tax services, money orders, and more, along with friendly and knowledgeable customer service! Need cash fast? We're here to help! 658 Main Street, Cincinnati, OH, 45202, CheckSmart is part of the Community Choice Financial network of nearly 500 locations nationwide. Community Choice is a national, neighborhood-based company that focuses on providing short-term loans, installment loans, check cashing, prepaid debit cards, and a variety of convenient financial services to help consumers manage day-to-day financial needs.",
    "openingHoursNotes": null,
    "lastSyncStarted": "2025-04-17T16:26:04.000+02:00",
    "country": "US",
    "lat": 39.10407853,
    "lng": -84.5102231,
    "imprint": null,
    "addressDisplay": true,
    "autoSync": true,
    "skipFacebookPicturesUpdate": false,
    "phone": "+1 513-929-4155",
    "status": "ACTIVE",
    "cleansingStatus": "CLEANSED",
    "cleansingInvalidDataReason": null,
    "photos": [
      {
        "id": 139742603,
        "dateCreated": "2025-04-17T16:23:21.000+02:00",
        "repoKey": "zNV16S353z.jpeg",
        "locationId": 4389559,
        "description": null,
        "identifier": null,
        "main": false,
        "logo": true,
        "type": "LOGO",
        "url": "/uploads/userpics/4389559/zNV16S353z.jpeg",
        "publicUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389559/medium_zNV16S353z.jpeg",
        "thumbnailUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389559/thumb_zNV16S353z.jpeg",
        "cropHeight": null,
        "cropWidth": null,
        "cropOffsetX": null,
        "cropOffsetY": null,
        "sourceUrl": "https://s3.eu-central-1.amazonaws.com/uberall-userpics-prod/4389559/OG2hHpXlKE.jpeg"
      }
    ],
    "keywords": [
      "check cashing cincinnati",
      "checksmart cincinnati"
    ],
    "labels": [
      {
        "name": "ohio",
        "adminOnly": true
      },
      {
        "name": "checksm",
        "adminOnly": true
      },
      {
        "name": "CheckSmart",
        "adminOnly": false
      }
    ],
    "categories": [
      2693,
      465,
      1688
    ],
    "locationSyncable": false,
    "businessId": 2014304,
    "socialPostId": null,
    "hasFacebook": false,
    "endDate": "2024-04-27T21:25:31.000+02:00",
    "averageRating": 4.7,
    "openingHours": [
      {
        "dayOfWeek": 1,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 2,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 3,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 4,
        "from1": "09:00",
        "to1": "19:00"
      },
      {
        "dayOfWeek": 5,
        "from1": "08:00",
        "to1": "20:00"
      },
      {
        "dayOfWeek": 6,
        "from1": "09:00",
        "to1": "16:00"
      }
    ],
    "specialOpeningHours": [
      {
        "date": "2025-05-26",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-07-04",
        "from1": "08:00",
        "to1": "16:00"
      },
      {
        "date": "2025-09-01",
        "from1": "09:00",
        "to1": "16:00"
      },
      {
        "date": "2025-11-27",
        "closed": true
      },
      {
        "date": "2025-12-25",
        "closed": true
      }
    ],
    "attributes": [
      {
        "externalId": "has_onsite_services",
        "displayName": "Onsite services",
        "valueType": "BOOL",
        "valueMetadata": [
          {
            "value": "true",
            "displayName": "Onsite services"
          }
        ],
        "groupDisplayName": "Service options",
        "value": "true"
      }
    ],
    "activeDirectoriesCount": 54,
    "activeListingsCount": 54,
    "publishedListingsCount": 51,
    "profileCompleteness": 100,
    "missingMandatoryFields": [],
    "directoriesMissingConnect": [
      "FACEBOOK"
    ],
    "listingsInSync": 45,
    "listingsBeingUpdated": 7,
    "directoriesPublishingStatus": [
      {
        "type": "GOOGLE",
        "status": "VERIFIED"
      }
    ],
    "visibilityIndex": 723,
    "dataPoints": 164,
    "province": "OH",
    "suggestionsForFieldsAvailable": true,
    "timeZone": "America/New_York"
  }
]